"use client"

import { useState, useEffect, useRef, useCallback } from "react";
import type React from "react";
import {
  ArrowLeft, Package, MoreVertical, Edit, Copy, Trash2, View, Share, Home, Search, Library, Heart, Settings, User,
  Play, Info, Plus, Star, X, Code, Save, LogOut, Upload, Shirt, Languages, ImageIcon, Palette, Scissors, Box, Type,
  Folder, Loader2, SaveAllIcon, Check,
  Form,
  Globe,
  Share2Icon,
} from "lucide-react";
import { Button } from "./components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger, } from "./components/ui/dialog";
import { Input } from "./components/ui/input";
import { Label } from "./components/ui/label";
import { Textarea } from "./components/ui/textarea";
import {
  Sidebar, SidebarContent, SidebarGroup, SidebarGroupContent, SidebarGroupLabel, SidebarHeader,
  SidebarInset, SidebarMenu, SidebarMenuButton, SidebarMenuItem, SidebarProvider, SidebarTrigger,
} from "./components/ui/sidebar";
import {
  deleteCatalog, deleteImage, deleteProjectAPI, deleteSeller, editCatalog,
  getCatalogs, registerAPI, registerCatalog, registerClient, registerImages,
  supbaseManager, getTeamMembers, getUserId, saveFolder, updateFolderProjects
} from "./API";
import { supabase } from "./supabaseClient";
import { Card, CardContent } from "./components/ui/card";
import { SellerManagementModal } from "./js/simulador/seller";
import { Users } from "lucide-react";
import { CategoryManager } from "./js/simulador/categories/categories";
import Categoires from "./js/simulador/categories2/categories";
import FormIframe from "./js/simulador/form/index";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './components/ui/select';
import { fabric } from "fabric";
import $ from "jquery";
import { FolderManager } from "./js/simulador/folders/folder-manager";
import {
  OptionsControlModal,
  defaultConfig,
  addColorOptions,
  createColorOption,
  type OptionsConfig,
  type ColorOption,
} from "./js/simulador/options-control-modal";
import { ColorTableModal } from "./js/simulador/color-table/color-table-modal";
import { ColorTableGrid } from "./js/simulador/color-table/color-table-grid";
import type { ColorTable } from "./lib/types";
// App.jsx ou qualquer página
import UniformForm from "./js/simulador/form2/uniform-form";
import DynamicList from "./js/simulador/DynamicList";
import JerseyBirdPage from './components/JerseyBirdPage';
import './styles/jerseybird.css';
import { ReloadIcon } from "@radix-ui/react-icons";

// Dados de exemplo para demonstração
const SAMPLE_TABLES: ColorTable[] = [];

// Função que será chamada quando salvar a configuração
function saveConfiguration(config: OptionsConfig) {
  const jsonConfig = JSON.stringify(config, null, 2)

  // Aqui você pode implementar a lógica para salvar no banco de dados
  // Por exemplo: fetch('/api/save-config', { method: 'POST', body: jsonConfig })

  alert("Configuração salva! Verifique o console para ver o JSON.")
}

// Cores padrão do modal
const defaultColors: ColorOption[] = []

// Exemplo: Adicionando novas cores personalizadas
var customColors = addColorOptions(defaultColors, [])


export type Seller = {
  id: string
  name: string
  phone: string
  photo: string | null
  seller_id: number
}

// Tipo do projeto
interface Project {
  id: number
  title: string
  thumbnail: string
  description: string
  category: string
  rating?: number
  createdAt?: string
  tags?: string[]
  author?: string
  status?: "active" | "draft" | "archived"
  sport_id: string
  svg_path: string
  id_data: number
  shared: string
  productionOrder: string
  designer: string
  body_state: boolean
  socks_state: boolean
  up_state: boolean
  down_state: boolean
  clone_state: boolean
  images: any
  inside_color: string

  up_state2: boolean
  collar: string
  filePath?: string

}

// Interfaces para os novos recursos
interface Background {
  id: number
  name: string
  url: string
  category: string
  tags?: string[]
  createdAt: string
}

interface ColorPalette {
  id: number
  name: string
  colors: string[]
  category: string
  tags?: string[]
  createdAt: string
}

interface Clipart {
  id: number
  name: string
  url: string
  category: string
  format: string
  tags?: string[]
  createdAt: string
}

interface Object3D {
  id: number
  name: string
  url: string
  category: string
  format: string
  tags?: string[]
  createdAt: string
}

interface Font {
  id: number
  name: string
  family: string
  url?: string
  category: string
  tags?: string[]
  createdAt: string
}

// Interface para adicionar projeto via API externa
interface ExternalProjectData {
  title: string
  description: string
  category: string
  thumbnail?: string
  rating?: number
  tags?: string[]
  author?: string
  status?: "active" | "draft" | "archived"
  sport_id: string
  svg_path: string
  id_data: number
  shared: string
  productionOrder: string
  designer: string
  body_state: boolean
  socks_state: boolean
  up_state: boolean
  down_state: boolean
  clone_state: boolean
  images: any
  inside_color: string

  up_state2: boolean
  collar: string
  file_path?: string
  filePath?: string
  createdAt: string
}

// Interface para projetos salvos
interface SavedProject {
  name: string
  projects: Project[]
  createdAt: string
}

// Dados iniciais dos projetos
const initialProjects: Project[] = []

// Categorias disponíveis
const categories = ["Tecnologia", "Negócios", "Design", "Dados", "Mobile", "Marketing", "Educação"]

// Itens do menu lateral
const menuItems = [
  { title: "Catálogos", icon: Folder, url: "#", id: "btn-catalog" },
  { title: "Editar Site", icon: Globe, url: "#", id: "btn-landing" },
]
{/**{ title: "Logout", icon: LogOut, url: "#", id: "btn-log-out" }, */ }
/*{ title: "Início", icon: Home, url: "#", id: "close-panel" },
  { title: "Idioma", icon: Languages, url: "#" },
  { title: "Logout", icon: LogOut, url: "#", id: "btn-log-out" },*/
//{ title: "Catálogos", icon: Folder, url: "#", id: "btn-catalog" },
//{ title: "Formulário", icon: Form, url: "#", id: "btn-form" },
// Novos itens para recursos
const resourceItems = [
  { title: "Fundos", icon: ImageIcon, type: "backgrounds" },
  { title: "Cores", icon: Palette, type: "colors", id: "open-modal-color-table" },
  { title: "Cliparts", icon: Scissors, type: "cliparts" },
  { title: "Modelagem", icon: Box, type: "objects3d" },
  { title: "Fontes", icon: Type, type: "fonts" },
]

// Define the type for menu items
interface DynamicItens {
  id: string
  label: string
}

// Define o tipo para as imagens
interface ProjectImage {
  id: string
  url: string
  projectId: number
}

// Componente do Card do Projeto
function ProjectCard({
  project,
  onDelete,
  dynamicMenuItems,
  selected,
  onToggle,
}: {
  project: Project
  onDelete: (id: number, id_data: number, path: string) => void
  dynamicMenuItems: DynamicItens[]
  selected?: boolean
  onToggle?: (id: number) => void
}) {
  // State to manage dynamic menu items
  //const [dynamicMenuItems, setDynamicMenuItems] = useState<DynamicItens[]>([])
  const [isImageModalOpen, setIsImageModalOpen] = useState(false)
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false)
  const [imageName, setImageName] = useState("")
  const [selectedFile, setSelectedFile] = useState<File | null>(null)
  const [previewUrl, setPreviewUrl] = useState<string>("")
  // Estado para gerenciar as imagens dos projetos
  const [projectImages, setProjectImages] = useState<ProjectImage[]>([]);

  const [open, setOpen] = useState(false)
  const [savedConfig, setSavedConfig] = useState<OptionsConfig>(defaultConfig)

  const handleSave = (config: OptionsConfig) => {
    setSavedConfig(config)
    saveConfiguration(config)
  }

  const openModalImage = async (id: any, projectId: any, images_array: any) => {

    for (var i = 0; i < (window as { [key: string]: any }).projectsImagesLoaded.length; i++) {
      if ((window as { [key: string]: any }).projectsImagesLoaded[i] == projectId) {
        return;
      }
    }

    (window as { [key: string]: any }).projectsImagesLoaded.push(projectId)

    //const images = await getImages(id) as any;

    for (var i = 0; i < images_array.length; i++) {
      const newImage: ProjectImage = {
        id: `img-${Date.now()}`,
        url: "https://nfghuenhuaecfyccyaib.supabase.co/storage/v1/object/public/images/" + images_array[i],
        projectId,
      }
      setProjectImages((prevImages) => [...prevImages, newImage])
    }

    {/**for (var i = 0; i < images.length; i++) {
      const newImage: ProjectImage = {
        id: images[i].id,
        url: images[i].image,
        projectId,
      }
      setProjectImages((prevImages) => [...prevImages, newImage])
    } */}
  }

  // Função para adicionar uma nova imagem
  const addProjectImage = async (projectId: number, imageUrl: any, id: any) => {

    registerImages(imageUrl, id);

    const newImage: ProjectImage = {
      id: `img-${Date.now()}`,
      url: imageUrl,
      projectId,
    }
    setProjectImages((prevImages) => [...prevImages, newImage])
  }

  // Função para converter arquivo para Data URL
  const fileToDataUrl = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => resolve(reader.result as string)
      reader.onerror = reject
      reader.readAsDataURL(file)
    })
  }

  // Função para remover uma imagem
  const removeProjectImage = (imageId: string) => {

    deleteImage(imageId)

    const imageToRemove = projectImages.find((img) => img.id === imageId)
    if (imageToRemove) {
      // Liberar a URL do objeto para evitar vazamentos de memória
      URL.revokeObjectURL(imageToRemove.url)
    }
    setProjectImages((prevImages) => prevImages.filter((img) => img.id !== imageId))
  }

  // Filtrar imagens do projeto atual
  const currentProjectImages = projectImages.filter((img) => img.projectId === project.id)

  // Função para lidar com a seleção de arquivo
  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      // Verificar se é uma imagem
      if (file.type.startsWith("image/")) {
        setSelectedFile(file)
        // Criar URL de preview
        const url = URL.createObjectURL(file)
        setPreviewUrl(url)
        // Se não há nome definido, usar o nome do arquivo (sem extensão)
        if (!imageName) {
          const nameWithoutExtension = file.name.replace(/\.[^/.]+$/, "")
          setImageName(nameWithoutExtension)
        }
      } else {
        alert("Por favor, selecione apenas arquivos de imagem.")
        event.target.value = ""
      }
    }
  }

  // Função para registrar nova imagem
  const handleRegisterImage = async (id: any) => {
    if (imageName.trim() && selectedFile) {

      const imageUrl = await fileToDataUrl(selectedFile)

      addProjectImage(project.id, imageUrl, id)
      // Limpar o formulário
      setImageName("")
      setSelectedFile(null)
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl)
        setPreviewUrl("")
      }
      setIsRegisterModalOpen(false)
    }
  }

  // Função para cancelar o registro
  const handleCancelRegister = () => {
    setImageName("")
    setSelectedFile(null)
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl)
      setPreviewUrl("")
    }
    setIsRegisterModalOpen(false)
  }

  const handleMenuClick = (id: any) => {

    (window as { [key: string]: any }).catalogFunctions.addPieceToCatalog(true, id, {
      name: project.title,
      image: project.thumbnail,
      price: 199.90,
      sport_id: project.id_data,
    })
  }

  return (
    <div className={`group relative overflow-hidden rounded-lg bg-card border transition-all duration-300 hover:shadow-xl hover:border-primary/50 ${selected ? "border-primary ring-2 ring-primary/30" : "border-border"} ${project.shared}`}>
      {/* Badge ID + Checkbox + Botão de deletar */}
      <div className="flex items-center justify-between px-3 pt-3 pb-1">
        <div className="flex items-center gap-2">
          {onToggle && (
            <button
              onClick={(e) => { e.stopPropagation(); onToggle(project.id) }}
              className={`flex-shrink-0 w-5 h-5 rounded border-2 flex items-center justify-center transition-all ${
                selected
                  ? "bg-primary border-primary text-primary-foreground"
                  : "border-muted-foreground/40 hover:border-primary/60"
              }`}
            >
              {selected && <Check className="h-3 w-3" strokeWidth={3} />}
            </button>
          )}
          <span className="text-xs font-semibold text-muted-foreground">ID: {project.id_data}</span>
        </div>
        <button
          onClick={() => onDelete(project.id, project.id_data, project.svg_path)}
          className="opacity-0 group-hover:opacity-100 transition-opacity bg-red-500 hover:bg-red-600 text-white rounded-full p-1"
        >
          <X className="h-3 w-3" />
        </button>
      </div>

      <div className="aspect-[3/4] overflow-hidden mx-3">
        <img
          src={(project.thumbnail || "/placeholder.svg") + "?v=" + encodeURIComponent(project.svg_path || String(project.id_data))}
          alt={project.title}
          className="h-full w-full object-contain transition-transform duration-300 group-hover:scale-105"
        />
      </div>

      <div className="p-3 project-list" id={"project-" + project.id_data}>
        <h3 className="mb-1 text-sm font-semibold text-foreground truncate">{project.title}</h3>
        {project.designer && (
          <span className="block text-xs font-semibold text-muted-foreground">
            Designer: {project.designer}
          </span>
        )}
        {project.productionOrder && (
          <span className="block text-xs text-muted-foreground">
            OP: {project.productionOrder}
          </span>
        )}
        {project.filePath ? (
          <div className="flex items-center gap-1 mt-1">
            <span className="text-xs text-muted-foreground truncate max-w-[180px]" title={project.filePath}>
              {project.filePath}
            </span>
            <button
              onClick={() => {
                navigator.clipboard.writeText(project.filePath || "");
              }}
              className="text-muted-foreground hover:text-foreground transition-colors shrink-0"
              title="Copiar caminho"
            >
              <Copy className="h-3 w-3" />
            </button>
          </div>
        ) : null}
        <p className="mb-3 text-xs text-muted-foreground">criado em: {new Date(project.createdAt as any).toLocaleDateString("pt-BR")}</p>

        <div className="flex gap-2">
          <Dialog>
            <DialogTrigger asChild>
              <Button
                size="sm"
                className={`flex-1 view-saved text-sm`}
                id={"pro-" + project.id_data}
                data-sport={project.sport_id}
                data-svg={project.svg_path}
                data-body={project.body_state}
                data-socks={project.socks_state}
                data-up2={project.up_state2}
                data-collar={project.collar}
                data-up={project.up_state}
                data-down={project.down_state}
                data-clone={project.clone_state}
                data-id={project.id_data}
                data-insidecolor={project.inside_color}
              >
                Visualizar
              </Button>
            </DialogTrigger>
          </Dialog>

          {!project.shared ?
            <div>
              <Button
                onClick={() => setOpen(true)}
                size="sm"
                variant="outline"
                className="gap-2 view-share px-2"
                data-sport={project.sport_id}
                data-svg={project.svg_path}
                data-body={project.body_state}
                data-socks={project.socks_state}
                data-up={project.up_state}
                data-up2={project.up_state2}
                data-collar={project.collar}
                data-down={project.down_state}
                data-clone={project.clone_state}
                data-id={project.id_data}
                data-insidecolor={project.inside_color}
              >
                <Upload className="h-4 w-4" />
              </Button>
              <OptionsControlModal
                open={open}
                onOpenChange={setOpen}
                initialConfig={savedConfig}
                onSave={handleSave}
                colorOptions={customColors}
              />
            </div>
            : null}
        </div>
      </div>
    </div>
  )
}

// Componente para salvar projeto
function SaveProjectDialog({ projects, onSave }: { projects: Project[]; onSave: (name: string) => void }) {
  const [open, setOpen] = useState(false)
  const [projectName, setProjectName] = useState("")
  const [isLoading, setIsLoading] = useState(false)

  const handleSave = async () => {
    if (!projectName.trim()) {
      alert("Por favor, digite um nome para o projeto")
      return
    }

    setIsLoading(true)

    try {
      // Simular salvamento (aqui você pode integrar com sua API)
      await new Promise((resolve) => setTimeout(resolve, 1000))

      onSave(projectName.trim())
      setProjectName("")
      setOpen(false)
        ; (window as { [key: string]: any })["saveProjectInput"]()
    } catch (error) {
      alert("Erro ao salvar projeto. Tente novamente.")
    } finally {
      setIsLoading(false)
    }
  }

  const handleCancel = () => {
    setProjectName("")
    setOpen(false)
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" className="bg-[green] text-white w-full">
          <Save className="mr-2 h-4 w-4 color-white" />
          Salvar Projeto
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Salvar Projeto</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div>
            <Label htmlFor="project-name mb-5">Nome do Projeto</Label>
            <Input
              id="project-name"
              value={projectName}
              onChange={(e) => setProjectName(e.target.value)}
              placeholder="Ex: Meu Catálogo de Projetos"
              onKeyDown={(e) => {
                if (e.key === "Enter" && !isLoading) {
                  handleSave()
                }
              }}
              disabled={isLoading}
            />
          </div>

          <div className="flex gap-2">
            <Button onClick={handleSave} className="flex-1" disabled={isLoading || !projectName.trim()}>
              {isLoading ? "Salvando..." : "Salvar"}
            </Button>
            <Button variant="outline" onClick={handleCancel} disabled={isLoading}>
              Cancelar
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

// Componente para testar a API externa
function ExternalAPIDemo({ onAddProject }: { onAddProject: (project: ExternalProjectData) => void }) {
  const [scriptCode, setScriptCode] = useState(`// Exemplo de uso da API externa
CatalogAPI.addProject({
title: "Projeto via Script",
description: "Este projeto foi adicionado via script externo!",
category: "Tecnologia",
thumbnail: "/placeholder.svg?height=300&width=400&text=Script",
rating: 4.7,
tags: ["JavaScript", "API", "External"],
author: "Script Automático",
status: "active"
});

// Adicionar múltiplos projetos
const projects = [
{
  title: "Projeto Batch 1",
  description: "Primeiro projeto do lote",
  category: "Design",
  rating: 4.2,
  tags: ["Batch", "Auto"]
},
{
  title: "Projeto Batch 2", 
  description: "Segundo projeto do lote",
  category: "Mobile",
  rating: 4.5,
  tags: ["Batch", "Mobile"]
}
];

CatalogAPI.addMultipleProjects(projects);

// Verificar projetos existentes
`)

  const executeScript = () => {
    try {
      // Criar um contexto seguro para executar o script
      const func = new Function("CatalogAPI", scriptCode)

      // Criar API mock para o script
      const mockAPI = {
        addProject: onAddProject,
        addMultipleProjects: (projects: ExternalProjectData[]) => {
          projects.forEach((project) => onAddProject(project))
        },
        getProjectCount: () => {
          return (window as any).catalogProjects?.length || 0
        },
        getAllProjects: () => {
          return (window as any).catalogProjects || []
        },
      }

      func(mockAPI)
    } catch (error) {
      console.error("Erro ao executar script:", error)
      alert("Erro ao executar script: " + error)
    }
  }

  return (
    <Dialog>
      <DialogTrigger asChild></DialogTrigger>
      <DialogContent className="max-w-4xl max-h-[80vh]">
        <DialogHeader>
          <DialogTitle>API Externa - Teste de Script</DialogTitle>
          <DialogDescription>Execute scripts externos para adicionar projetos programaticamente</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label htmlFor="script">Código JavaScript</Label>
            <Textarea
              id="script"
              value={scriptCode}
              onChange={(e) => setScriptCode(e.target.value)}
              className="font-mono text-sm min-h-[300px]"
              placeholder="Digite seu código JavaScript aqui..."
            />
          </div>
          <div className="flex gap-2">
            <Button onClick={executeScript}>Executar Script</Button>
            <Button
              variant="outline"
              onClick={() =>
                setScriptCode(`CatalogAPI.addProject({
title: "Meu Projeto",
description: "Descrição do projeto",
category: "Tecnologia",
rating: 5.0,
tags: ["tag1", "tag2"],
author: "Seu Nome"
});`)
              }
            >
              Exemplo Simples
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

type ItemFont = {
  label: string
  value: string
  font: string
  class_name: string
}

// Componente de upload de arquivo com visual customizado
function FileUpload({
  label,
  required,
  accept,
  file,
  onFileChange,
}: {
  label: string
  required?: boolean
  accept: string
  file: File | null
  onFileChange: (file: File) => void
}) {
  const id = `file-${label.replace(/\s+/g, "-").toLowerCase()}`

  return (
    <div className="space-y-1.5">
      <Label htmlFor={id}>
        {label} {required && <span className="text-destructive">*</span>}
      </Label>
      <label
        htmlFor={id}
        className="flex items-center gap-3 h-10 px-3 rounded-md border border-input bg-transparent cursor-pointer hover:bg-accent/50 transition-colors group"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="text-muted-foreground group-hover:text-foreground transition-colors"
        >
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="17 8 12 3 7 8" />
          <line x1="12" x2="12" y1="3" y2="15" />
        </svg>
        <span className="text-sm text-muted-foreground truncate flex-1">
          {file ? file.name : "Escolher arquivo"}
        </span>
        <input
          id={id}
          type="file"
          accept={accept}
          className="hidden"
          onChange={(e) => {
            const f = e.target.files?.[0]
            if (f) onFileChange(f)
          }}
          required={required}
        />
      </label>
    </div>
  )
}

// Componente para modais de recursos
function ResourceModal({
  items,
  type,
  isOpen,
  onClose,
  onSave,
}: {
  items: ItemFont[]
  type: string
  isOpen: boolean
  onClose: () => void
  onSave: (data: any) => void
}) {
  const [formData, setFormData] = useState<any>({
    name: "",
    obj: null,
    svg: null,

    tecidos: [],
    collar: "",
    sleeve: "",
    escudos: [],

    sizes: "",
    desc: "",
    price: "",
    discount: "",
    thumbnail: null
  })
  const [isLoading, setIsLoading] = useState(false)
  const [svgColors, setSvgColors] = useState<string[]>([])


  const resetForm = () => {
    setFormData({})
  }

  const handleSave = async () => {
    setIsLoading(true)
    try {
      await new Promise((resolve) => setTimeout(resolve, 500))
      onSave({
        ...formData,
        id: Date.now(),
        createdAt: new Date().toISOString(),
      })
      resetForm()
      onClose()
      //alert(`${getResourceTitle(type)} salvo com sucesso!`)
    } catch (error) {
      alert("Erro ao salvar. Tente novamente.")
    } finally {
      setIsLoading(false)
    }
  }

  const getResourceTitle = (type: string) => {
    const titles: Record<string, string> = {
      backgrounds: "Fundo",
      colors: "Paleta de Cores",
      cliparts: "Clipart",
      objects3d: "Modelagem",
      fonts: "Fonte",
    }
    return titles[type] || "Recurso"
  }

  const loadFonts = function () {
    (window as any)["loadFonts"]();
  }

  function extractColors(obj: fabric.Object, colorSet: Set<string>) {
    const anyObj = obj as any

    if (anyObj._objects) {
      anyObj._objects.forEach((child: fabric.Object) => {
        extractColors(child, colorSet)
      })
      return
    }

    // Fill sólido
    if (typeof obj.fill === "string" && obj.fill !== "none") {
      colorSet.add(obj.fill)
    }

    // Gradiente
    if ((obj.fill as any)?.colorStops) {
      ; (obj.fill as any).colorStops.forEach((stop: any) => {
        if (stop.color) colorSet.add(stop.color)
      })
    }

    // Stroke
    if (typeof obj.stroke === "string" && obj.stroke !== "none") {
      colorSet.add(obj.stroke)
    }
  }

  const handleSVGUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) return

    const url = URL.createObjectURL(file)

    setFormData({ image: file, url })

    fabric.loadSVGFromURL(url, (objects, options) => {
      const svg = fabric.util.groupSVGElements(objects, options)

      const colorSet = new Set<string>()
      extractColors(svg, colorSet)

      setSvgColors(Array.from(colorSet))
    })
  }

  const renderFormFields = () => {
    switch (type) {
      case "backgrounds":
        return (
          <>
            <div className="hidden">
              <Label htmlFor="bg-name">Nome do Fundo *</Label>
              <Input
                id="bg-name"
                value={"name"}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                placeholder="Ex: Fundo Gradiente Azul"
                required
              />
            </div>
            <div>
              <Label htmlFor="bg-image">Imagem do Fundo</Label>
              <Input
                id="bg-image"
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files?.[0]
                  if (file) {
                    const url = URL.createObjectURL(file)
                    setFormData({ ...formData, image: file, url: url })
                  }
                }}
                required
              />
              {formData.url && (
                <div className="mt-2">
                  <img
                    src={formData.url || "/placeholder.svg"}
                    alt="Preview"
                    className="w-full h-32 object-cover rounded border"
                  />
                </div>
              )}
            </div>
            {/**<div>
            <Label htmlFor="bg-category">Categoria</Label>
            <Input
              id="bg-category"
              value={formData.category || ""}
              onChange={(e) => setFormData({ ...formData, category: e.target.value })}
              placeholder="Ex: Gradientes, Texturas, Abstratos"
            />
          </div>
          <div>
            <Label htmlFor="bg-tags">Tags (separadas por vírgula)</Label>
            <Input
              id="bg-tags"
              value={formData.tags || ""}
              onChange={(e) =>
                setFormData({ ...formData, tags: e.target.value.split(",").map((t: string) => t.trim()) })
              }
              placeholder="azul, gradiente, moderno"
            />
          </div> */}
          </>
        )

      case "cliparts":
        return (
          <>
            <div className="hidden">
              <Label htmlFor="clip-name">Nome do Conjunto</Label>
              <Input
                id="clip-name"
                value={"name"}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                placeholder="Ex: Ícone Coração"
              />
            </div>
            <div>
              <Label htmlFor="rg-cliparts">Cliparts (svgs) *</Label>
              <Input
                id="rg-cliparts"
                type="file"
                multiple
                accept="image/svg+xml"
                onChange={(e) => {
                  const files = e.target.files

                  if (files && files.length > 0) {
                    const fileArray = Array.from(files) // ensures it's a real array
                    const urls = fileArray.map((file) => URL.createObjectURL(file))

                    setFormData({
                      ...formData,
                      image: fileArray,
                      url: urls,
                    })
                  }
                }}
                required
              />
            </div>
            <div id="list-cliparts-register" className="cliparts-preview grid grid-cols-6 gap-2 max-h-[500px] overflow-y-auto">
              {formData.url?.map((url: any, index: any) => (
                <div key={index} className="clipart-item bg-primary/50 flex justify-center">
                  <img className="max-h-[50px]" src={url} alt={`clipart-${index}`} />
                </div>
              ))}
            </div>
          </>
        )

      case "objects3d":
        return (
          <div className="space-y-4">
            {/* Informações Básicas */}
            <section className="bg-secondary/50 p-4 rounded-lg space-y-3">
              <h4 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
                Informações Básicas
              </h4>
              <div className="grid grid-cols-3 gap-3">
                <div className="space-y-1.5">
                  <Label htmlFor="obj-name">Nome da Modelagem *</Label>
                  <Input
                    id="obj-name"
                    value={formData.name || ""}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    placeholder="Ex: Alfa Ksport"
                  />
                </div>
                <div className="space-y-1.5">
                  <Label htmlFor="obj-desc">Descrição (opcional)</Label>
                  <Input
                    id="obj-desc"
                    value={formData.desc || ""}
                    onChange={(e) => setFormData({ ...formData, desc: e.target.value })}
                    placeholder="Ex: Básico com encaixe trad"
                  />
                </div>
                <div className="space-y-1.5">
                  <Label htmlFor="obj-category">Categoria (opcional)</Label>
                  <Input
                    id="obj-category"
                    value={formData.category || ""}
                    onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                    placeholder="Ex: Futebol, Basquete"
                  />
                </div>
              </div>
            </section>

            {/* Preço e Tamanhos */}
            <section className="bg-secondary/50 p-4 rounded-lg space-y-3">
              <h4 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
                Preço e Tamanhos
              </h4>
              <div className="grid grid-cols-3 gap-3">
                <div className="space-y-1.5">
                  <Label htmlFor="obj-sizes">Tamanhos</Label>
                  <Input
                    id="obj-sizes"
                    value={formData.sizes || ""}
                    onChange={(e) => setFormData({ ...formData, sizes: e.target.value })}
                    placeholder="Ex: P, M, G"
                  />
                </div>
                <div className="space-y-1.5">
                  <Label htmlFor="obj-price">Preço</Label>
                  <Input
                    id="obj-price"
                    value={formData.price || ""}
                    onChange={(e) => setFormData({ ...formData, price: e.target.value })}
                    placeholder="Ex: R$ 199,90"
                  />
                </div>
                <div className="space-y-1.5">
                  <Label htmlFor="obj-discount">Desconto (separe por vírgula)</Label>
                  <Input
                    id="obj-discount"
                    value={formData.discount || ""}
                    onChange={(e) => setFormData({ ...formData, discount: e.target.value })}
                    placeholder="Ex: 10, 20, 30"
                  />
                </div>
              </div>
            </section>

            {/* Arquivos */}
            <section className="bg-secondary/50 p-4 rounded-lg space-y-3">
              <h4 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
                Arquivos
              </h4>
              <div className="grid grid-cols-3 gap-3">
                <FileUpload
                  label="Objeto (.glb)"
                  required
                  accept=".glb"
                  file={formData.obj}
                  onFileChange={(file) => {
                    const url = URL.createObjectURL(file)
                    setFormData({ ...formData, obj: file, url })
                  }}
                />
                <FileUpload
                  label="Mapa SVG (.svg)"
                  required
                  accept="image/svg+xml"
                  file={formData.svg}
                  onFileChange={(file) => {
                    const url = URL.createObjectURL(file)
                    setFormData({ ...formData, svg: file, url })
                  }}
                />
                <FileUpload
                  label="Thumbnail (imagem)"
                  required
                  accept="image/*"
                  file={formData.thumbnail}
                  onFileChange={(file) => {
                    const url = URL.createObjectURL(file)
                    setFormData({ ...formData, thumbnail: file, url })
                  }}
                />
              </div>
            </section>

            {/* Modelo */}
            <section className="bg-secondary/50 p-4 rounded-lg space-y-3">
              <h4 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
                Modelo
              </h4>
              <div className="grid grid-cols-2 gap-3">
                <div className="space-y-1.5">
                  <Label htmlFor="obj-collar">Tipo de Gola</Label>
                  <Input
                    id="obj-collar"
                    value={formData.collar || ""}
                    onChange={(e) => setFormData({ ...formData, collar: e.target.value })}
                    placeholder="Ex: Gola V"
                  />
                </div>
                <div className="space-y-1.5">
                  <Label htmlFor="obj-sleeve">Tipo de Manga</Label>
                  <Input
                    id="obj-sleeve"
                    value={formData.sleeve || ""}
                    onChange={(e) => setFormData({ ...formData, sleeve: e.target.value })}
                    placeholder="Ex: Raglan"
                  />
                </div>
              </div>
            </section>

            {/* Tecidos e Escudos */}
            <section className="bg-secondary/50 p-4 rounded-lg space-y-4">
              <h4 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
                Tecidos e Escudos
              </h4>
              <div className="grid grid-cols-2 gap-4">
                <DynamicList
                  label="Tecidos"
                  items={formData.tecidos}
                  setItems={(items: any) =>
                    setFormData({ ...formData, tecidos: items })
                  }
                  hasImage
                />
                <DynamicList
                  label="Escudos"
                  items={formData.escudos}
                  setItems={(items: any) =>
                    setFormData({ ...formData, escudos: items })
                  }
                  hasImage
                />
              </div>
            </section>
          </div>
        )

      case "fonts":
        return (
          <>
            <div className="w-full">
              <Select onOpenChange={(open) => {
                if (open) loadFonts();
              }} >
                <SelectTrigger className="w-[220px]">
                  <SelectValue placeholder="Fontes Registradas" />
                </SelectTrigger>

                <SelectContent>
                  {items.map(item => (
                    <SelectItem className={item.class_name} key={item.value} value={item.value} style={{ fontFamily: item.font }}>
                      {item.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="hidden">
              <Label htmlFor="font-name">Nome do Conjunto</Label>
              <Input
                id="font-name"
                value={"name"}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                placeholder="Ex: Nome"
              />
            </div>
            <div>
              <Label htmlFor="rg-fonts">Fontes (.ttf) *</Label>
              <Input
                id="rg-fonts"
                type="file"
                multiple
                accept=".ttf"
                onChange={(e) => {
                  const files = e.target.files

                  if (files && files.length > 0) {
                    const fileArray = Array.from(files) // ensures it's a real array
                    const urls = fileArray.map((file) => URL.createObjectURL(file))

                    setFormData({
                      ...formData,
                      image: fileArray,
                      url: urls,
                    })
                  }
                }}
                required
              />
            </div>
          </>
        )

      default:
        return null
    }
  }

  const isFormValid = () => {
    switch (type) {
      case "backgrounds":
        return !!formData.image
      case "colors":
        return !!formData.image
      case "cliparts":
        return Array.isArray(formData.image) && formData.image.length > 0
      case "objects3d":
        return !!formData.obj && !!formData.svg
      case "fonts":
        return Array.isArray(formData.image) && formData.image.length > 0
      default:
        return false // Se o tipo não for reconhecido ou não tiver campos obrigatórios
    }
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-[750px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Adicionar {getResourceTitle(type)}</DialogTitle>
          <DialogDescription>
            Preencha os dados para adicionar um novo {getResourceTitle(type).toLowerCase()}.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          {renderFormFields()}

          <div className="flex gap-2">
            <Button onClick={handleSave} className="flex-1" disabled={isLoading || !isFormValid()}>
              {isLoading ? "Salvando..." : "Salvar"}
            </Button>
            <Button variant="outline" onClick={onClose} disabled={isLoading}>
              Cancelar
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

// Componente do Sidebar
function AppSidebar({
  selectedCategory,
  onCategoryChange,
  projects,
  onSaveProject,
  onOpenResourceModal,
  onOpenSellers,
  onOpenStoreData,
  onShareForm,
  isVendedor,
}: {
  selectedCategory: string
  onCategoryChange: (category: string) => void
  projects: Project[]
  onSaveProject: (name: string) => void
  onOpenResourceModal: (type: string) => void
  onOpenSellers: () => void
  onOpenStoreData: () => void
  onShareForm: () => void
  isVendedor: boolean
}) {

  const onShareSite = function () {

    const copyText = (window as { [key: string]: any }).location.host + "/?site=" + localStorage.getItem("supa_client_id");//share

    // Copy the text inside the text field
    navigator.clipboard.writeText(copyText);

    alert("Link Copiado!");
  }

  return (
    <Sidebar>
      <SidebarHeader>
        <div className="flex items-center gap-2 px-4 py-2">
          <img id="logopp" src='./mantos.png'></img>
        </div>
      </SidebarHeader>

      <SidebarContent>
        {!isVendedor && (
          <SidebarGroup>
            <SidebarGroupLabel>Menu Principal</SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                {menuItems.map((item) => (
                  <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton asChild>
                      <a href={item.url} className="flex items-center gap-3" id={item.id}>
                        <item.icon className="h-4 w-4" />
                        <span>{item.title}</span>
                      </a>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}

                {/* Botão de Salvar no Menu Principal 
                <SidebarMenuItem>
                  <SaveProjectDialog projects={projects} onSave={onSaveProject} />
                </SidebarMenuItem>*/}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        )}

        {!isVendedor && (
          <SidebarGroup>
            <SidebarGroupLabel>Registrar</SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                {resourceItems.map((item) => (
                  <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton id={item.id} onClick={!item.id ? () => onOpenResourceModal(item.type) : undefined}>
                      <item.icon className="h-4 w-4" />
                      <span>{item.title}</span>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        )}

        {/* Botões no rodapé da sidebar */}
        <div className="mt-auto p-3 space-y-2 border-t">
          {!isVendedor && (
            <Button id="btn-pilha-svgs" variant="outline" size="sm" className="w-full justify-start gap-2 bg-[green] hover:bg-orange-600 text-white view-share">
              <SaveAllIcon></SaveAllIcon>
              Importar Vários
              <input accept=".svg,image/svg+xml" id="input-project-pilha" type="file" className="opacity-0 absolute w-[100px]" multiple></input>
            </Button>
          )}
          {!isVendedor && (
            <Button
              onClick={onShareSite}
              variant="default"
              size="sm"
              className="w-full justify-start gap-2 bg-orange-500 hover:bg-orange-600 text-white view-share"
            >
              <Share2Icon className="h-4 w-4"></Share2Icon>
              Compartilhar Site
            </Button>
          )}
          <Button
            variant="default"
            size="sm"
            className="w-full justify-start gap-2 bg-[red] hover:bg-orange-600 text-white view-share"
          >
            <ReloadIcon></ReloadIcon>
            <a
              href="https://mantosfc.com/login"
              target="_blank"
              rel="noopener noreferrer"
            >
              Mudar Senha
            </a>
          </Button>
          {!isVendedor && (
            <Button
              onClick={onOpenSellers}
              variant="outline"
              size="sm"
              className="w-full justify-start gap-2"
            >
              <Users className="h-4 w-4" />
              Vendedores
            </Button>
          )}
          <Button
            onClick={onOpenStoreData}
            variant="outline"
            size="sm"
            className="w-full justify-start gap-2"
          >
            <User className="h-4 w-4" />
            Dados da Loja
          </Button>
        </div>
      </SidebarContent>
    </Sidebar>
  )
}

const categories2 = [
  { id: 'todos', label: 'Todos os meus projetos', index: 0 }
]


export function Projects({
  onSaveProject,
}: {
  onSaveProject: (name: string) => void
}) {

  const [category, setCategory] = useState('todos');
  const [categories, setCategories] = useState(categories2);
  const [isClientDataModalOpen, setIsClientDataModalOpen] = useState(false)

  const [projects, setProjects] = useState<Project[]>(initialProjects)
  const [projects2, setProjects2] = useState<Project[]>(initialProjects)
  const [selectedCategory, setSelectedCategory] = useState("")
  const [searchTerm, setSearchTerm] = useState("")
  const [savedProjects, setSavedProjects] = useState<SavedProject[]>([])

  // Filtros avançados
  const [filterName, setFilterName] = useState("")
  const [filterDesigner, setFilterDesigner] = useState("")
  const [filterId, setFilterId] = useState("")
  const [filterOP, setFilterOP] = useState("")
  const [filterDateFrom, setFilterDateFrom] = useState("")
  const [filterDateTo, setFilterDateTo] = useState("")
  const [sortField, setSortField] = useState<"title" | "designer" | "id_data" | "productionOrder" | "createdAt">("createdAt")
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("desc")
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false)
  const [activeView, setActiveView] = useState("projects-all")
  const projectsRef = useRef(projects)

  // ── Bulk selection ──
  const [selectedIds, setSelectedIds] = useState<Set<number>>(new Set())

  // Infinite scroll
  const PROJECT_BATCH = 40
  const [visibleCount, setVisibleCount] = useState(PROJECT_BATCH)
  const [visibleCount2, setVisibleCount2] = useState(PROJECT_BATCH)
  const sentinelRef = useRef<HTMLDivElement>(null)
  const sentinelRef2 = useRef<HTMLDivElement>(null)

  // New state for global dynamic menu items
  const [globalDynamicMenuItems, setGlobalDynamicMenuItems] = useState<DynamicItens[]>([])

  // Estados para os novos recursos
  const [backgrounds, setBackgrounds] = useState<Background[]>([])
  const [colorPalettes, setColorPalettes] = useState<ColorPalette[]>([])
  const [cliparts, setCliparts] = useState<Clipart[]>([])
  const [objects3d, setObjects3d] = useState<Object3D[]>([])
  const [fonts, setFonts] = useState<Font[]>([])

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isModalOpen2, setIsModalOpen2] = useState(false)
  const [isModalOpenCat, setIsModalCatOpen] = useState(false)
  const [sellers, setSellers] = useState<Seller[]>([])

  const [isModalColorOpen, setIsModalColorOpen] = useState(false)
  const [tables, setTables] = useState<ColorTable[]>(SAMPLE_TABLES)

  const [open2, setOpen2] = useState(false)
  const [savedConfig2, setSavedConfig2] = useState<OptionsConfig>(defaultConfig)

  const handleSave2 = (config: OptionsConfig) => {
    setSavedConfig2(config)
    saveConfiguration(config)
  }

  const handleSave = async (colorTable: ColorTable) => {
    setTables((prev) => [colorTable, ...prev])

    // Aqui você pode chamar sua API para salvar no banco de dados
    // Exemplo:
    // await fetch('/api/color-tables', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify(colorTable),
    // })

    const data = await supbaseManager("insert", "color-tables", {
      user_id: getUserId(),
      content: JSON.stringify(colorTable)
    });
  }

  const handleDelete = (id: string) => {
    setTables((prev) => prev.filter((t) => t.id !== id))

    // Aqui você pode chamar sua API para deletar do banco de dados
    // Exemplo:
    // await fetch(`/api/color-tables/${id}`, { method: 'DELETE' })
  }

  const handleDuplicate = (table: ColorTable) => {
    /*const duplicated: ColorTable = {
      ...table,
      id: generateId(),
      name: `${table.name} (Cópia)`,
      createdAt: new Date(),
      updatedAt: new Date(),
    }
    setTables((prev) => [duplicated, ...prev])*/
  }

  const handleAddSeller = (seller: Omit<Seller, "id">) => {

    const newSeller: Seller = {
      ...seller,
      id: Math.random().toString(),
    }
    setSellers((prev) => [...prev, newSeller])
  }

  const handleRemoveSeller = (id: string, seller_id: number) => {
    deleteSeller(seller_id);
    setSellers((prev) => prev.filter((seller) => seller.id !== id))
  }

  // Estado para controlar qual modal está aberto
  const [activeResourceModal, setActiveResourceModal] = useState<string | null>(null)

  // ── Equipe (designers e vendedores da mesma organização) ──
  // Não tem cadastro: cada conta define o próprio cargo em "Dados da Loja";
  // aqui só listamos, de forma somente leitura, quem já definiu o cargo.
  const [teamMembers, setTeamMembers] = useState<{ id: string; name: string; email: string; role: "designer" | "vendedor" | "gestao" }[]>([])

  const loadTeamMembers = async () => {
    const data = await getTeamMembers()
    setTeamMembers(data || [])
  }

  const [clientData, setClientData] = useState<ClientData>({
    logo: null,
    description: "",
    phone: "",
    name: "",
    banner_print_top: null,
    banner_print_bottom: null,
    catalog_banner_top: null,
    cnpj: "",
    end: "",
    email: "",
    site: "",
    instagram: "",
    whatsapp: "",
    horario: "",
    pedido_min: "",
    prazo: "",
    pagamento: "",
    role: "",
    user_name: ""
  })
  const [tempClientData, setTempClientData] = useState<ClientData>({
    logo: null,
    description: "",
    phone: "",
    name: "",
    banner_print_top: null,
    banner_print_bottom: null,
    catalog_banner_top: null,
    cnpj: "",
    end: "",
    email: "",
    site: "",
    instagram: "",
    whatsapp: "",
    horario: "",
    pedido_min: "",
    prazo: "",
    pagamento: "",
    role: "",
    user_name: ""
  })

  const [items, setItems] = useState<ItemFont[]>([])

  // Expor função global
  useEffect(() => {
    (window as any).addSelectItemFont = (label: any, value: any, font: any, class_name: any) => {
      setItems(prev => [...prev, { label, value, font, class_name }])
    }
  }, [])

  const handleLogoUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        setTempClientData({ ...tempClientData, logo: e.target?.result as string })
      }
      reader.readAsDataURL(file)
    }
  }

  const handleBannerPrintTopUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        setTempClientData({ ...tempClientData, banner_print_top: e.target?.result as string })
      }
      reader.readAsDataURL(file)
    }
  }

  const handleBannerPrintBottomUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        setTempClientData({ ...tempClientData, banner_print_bottom: e.target?.result as string })
      }
      reader.readAsDataURL(file)
    }
  }

  const handleBannerCatalogTopUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        setTempClientData({ ...tempClientData, catalog_banner_top: e.target?.result as string })
      }
      reader.readAsDataURL(file)
    }
  }

  const isClientDataValid = () => {
    return tempClientData.logo !== null && tempClientData.description.trim() !== "" &&
      tempClientData.phone.trim() !== ""
  }

  async function dataURLtoFile(dataUrl: string, filename: string): Promise<File> {
    return new Promise((resolve, reject) => {
      try {
        const arr = dataUrl.split(',');
        const mime = arr[0].match(/:(.*?);/)?.[1] || '';
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }

        resolve(new File([u8arr], filename, { type: mime }));
      } catch (err) {
        reject(err);
      }
    });
  }

  const handleSaveClientData = async () => {
    try {
      if (tempClientData.banner_print_top)
        $("#banner_print_top").css("background-image", "url(" + tempClientData.banner_print_top + ")");

      if (tempClientData.banner_print_bottom)
        $("#banner_print_bottom").css("background-image", "url(" + tempClientData.banner_print_bottom + ")");

      var logo, banner_print_top, banner_print_bottom, catalog_banner_top;

      if (tempClientData.logo)
        if (tempClientData.logo.includes("data:image"))
          logo = await dataURLtoFile(tempClientData.logo, "image.png");

      if (tempClientData.banner_print_top)
        if (tempClientData.banner_print_top.includes("data:image"))
          banner_print_top = await dataURLtoFile(tempClientData.banner_print_top, "image.png");

      if (tempClientData.banner_print_bottom)
        if (tempClientData.banner_print_bottom.includes("data:image"))
          banner_print_bottom = await dataURLtoFile(tempClientData.banner_print_bottom, "image.png");

      if (tempClientData.catalog_banner_top)
        if (tempClientData.catalog_banner_top.includes("data:image"))
          catalog_banner_top = await dataURLtoFile(tempClientData.catalog_banner_top, "image.png");

      await registerClient(logo, tempClientData.name, tempClientData.description, tempClientData.phone,
        banner_print_top, banner_print_bottom, catalog_banner_top, tempClientData.email, tempClientData.end,
        tempClientData.cnpj, tempClientData.site, tempClientData.instagram, tempClientData.whatsapp, tempClientData.horario,
        tempClientData.pedido_min, tempClientData.prazo, tempClientData.pagamento, tempClientData.role, tempClientData.user_name);

      setClientData(tempClientData)
      setIsClientDataModalOpen(false)
    } catch (e: any) {
      console.error("[handleSaveClientData] erro:", e)
      ;(window as any).stateLoadinScreen2?.(false)
      ;(window as any).toast?.("Erro ao salvar!", "error")
    }
  }

  const handleCancelClientData = () => {
    setTempClientData(clientData)
    setIsClientDataModalOpen(false)
  }


  const [isCatalogModalOpen, setIsCatalogModalOpen] = useState(false)
    ; (window as { [key: string]: any })["stateModalCatalog"] = () => {
      setIsCatalogModalOpen(true)
    }

  // Função para abrir modal de recurso
  const openResourceModal = (type: string) => {
    setActiveResourceModal(type)
  }

  // Função para fechar modal de recurso
  const closeResourceModal = () => {
    setActiveResourceModal(null)
  }

  // Função para salvar recurso
  const saveResource = async (type: string, data: any) => {
    switch (type) {
      case "backgrounds":
        (window as any).addBackground?.({
          name: data.name,
          url: data.url,
          isTemp: true
        });
        registerAPI(data, "backgrounds", false)
        //setBackgrounds((prev) => [...prev, data])
        break
      case "colors":
        registerAPI(data, "cores", true)
        //setColorPalettes((prev) => [...prev, data])
        break
      case "cliparts":
        //setCliparts((prev) => [...prev, data])
        registerAPI(data, "cliparts", true)
        break
      case "objects3d":
        //return
        //console.log(data)
        const url = URL.createObjectURL(data.obj);
        const thumb = await (window as any)["generateGLBThumbnail"](url);
        //console.log(thumb)

        const res = await fetch(thumb)
        const blob = await res.blob()

        registerAPI(data, "3ds", true, blob)
        //setObjects3d((prev) => [...prev, data])
        break
      case "fonts":
        registerAPI(data, "fonts", true)
        //setFonts((prev) => [...prev, data])
        break
    }
  }

  // Manter referência atualizada dos projetos
  useEffect(() => {
    projectsRef.current = projects
      // Expor projetos globalmente para scripts externos
      ; (window as any).catalogProjects = projects;

    (window as { [key: string]: any })["setClientData"] = (
      name: any, logo: any, description: any, phone: any, banner_print_top: any, banner_print_bottom: any, catalog_banner_top: any, cnpj: any, end: any,
      email: any, site: any, instagram: any, whatsapp: any, horario: any, pedido_min: any, prazo: any, pagamento: any, role: any, user_name: any) => {
      setTempClientData({
        logo: logo,
        description: description,
        phone: phone,
        name: name,
        banner_print_top: banner_print_top,
        banner_print_bottom: banner_print_bottom,
        catalog_banner_top: catalog_banner_top,
        cnpj: cnpj,
        end: end,
        email: email,
        site: site,
        instagram: instagram,
        whatsapp: whatsapp,
        horario: horario,
        pedido_min: pedido_min,
        prazo: prazo,
        pagamento: pagamento,
        role: role || "",
        user_name: user_name || ""
      })
    }

    // Permite abrir "Dados da Loja" direto de fora (ex: botão de atalho no editor)
    ;(window as { [key: string]: any })["openStoreDataModal"] = () => {
      loadTeamMembers()
      setIsClientDataModalOpen(true)
    }
  }, [projects])

  // Função para salvar projeto
  const saveProject = (name: string) => {
    const savedProject: SavedProject = {
      name,
      projects: [...projects], // Cópia dos projetos atuais
      createdAt: new Date().toISOString(),
    }

    setSavedProjects((prev) => [...prev, savedProject]);

    // Salvar no localStorage para persistência
    /*const existingSaved = JSON.parse(localStorage.getItem("savedProjects") || "[]")
    const updatedSaved = [...existingSaved, savedProject]
    localStorage.setItem("savedProjects", JSON.stringify(updatedSaved))

      ; */
    (window as { [key: string]: any })["SetProjectName"](name)
  }

  // Carregar projetos salvos do localStorage na inicialização
  useEffect(() => {
    /*const saved = localStorage.getItem("savedProjects")
    if (saved) {
      setSavedProjects(JSON.parse(saved))
    }*/
  }, [])

  // Função para adicionar projeto via API externa
  type AddProjectOptions = {
    prepend?: boolean; // true = adiciona no começo
  }

  const addProjectFromExternal = (
    projectData: ExternalProjectData,
    options: AddProjectOptions = {},
  ) => {
    const newProject: Project = {
      id: projectData.id_data,
      title: projectData.title,
      description: projectData.description,
      category: projectData.category,
      thumbnail:
        projectData.thumbnail ||
        `/placeholder.svg?height=300&width=400&text=${encodeURIComponent(projectData.title)}`,
      rating: projectData.rating || 5.0,
      tags: projectData.tags || [],
      author: projectData.author || "Usuário Externo",
      status: projectData.status || "active",
      createdAt: projectData.createdAt,
      sport_id: projectData.sport_id || "",
      svg_path: projectData.svg_path || "",
      id_data: projectData.id_data,
      shared: projectData.shared,

      body_state: projectData.body_state,
      socks_state: projectData.socks_state,
      up_state: projectData.up_state,
      down_state: projectData.down_state,
      clone_state: projectData.clone_state,
      images: projectData.images,
      inside_color: projectData.inside_color,

      up_state2: projectData.up_state2,
      collar: projectData.collar,
      productionOrder: projectData.productionOrder,
      designer: projectData.designer,
      filePath: projectData.file_path || projectData.filePath
    }

    setProjects((prev) => {
      if (prev.some((p) => p.id_data === newProject.id_data)) return prev;

      return options.prepend ? [newProject, ...prev] : [...prev, newProject];
    });

    window.dispatchEvent(new CustomEvent("projectAdded", { detail: newProject }))
    return newProject
  }

  const addProjectFromExternal2 = (
    projectData: ExternalProjectData,
    options: AddProjectOptions = {},
  ) => {
    const newProject: Project = {
      id: projectData.id_data,
      title: projectData.title,
      description: projectData.description,
      category: projectData.category,
      thumbnail:
        projectData.thumbnail ||
        `/placeholder.svg?height=300&width=400&text=${encodeURIComponent(projectData.title)}`,
      rating: projectData.rating || 5.0,
      tags: projectData.tags || [],
      author: projectData.author || "Usuário Externo",
      status: projectData.status || "active",
      createdAt: projectData.createdAt,
      sport_id: projectData.sport_id || "",
      svg_path: projectData.svg_path || "",
      id_data: projectData.id_data,
      shared: projectData.shared,

      body_state: projectData.body_state,
      socks_state: projectData.socks_state,
      up_state: projectData.up_state,
      down_state: projectData.down_state,
      clone_state: projectData.clone_state,
      images: projectData.images,
      inside_color: projectData.inside_color,

      up_state2: projectData.up_state2,
      collar: projectData.collar,
      productionOrder: projectData.productionOrder,
      designer: projectData.designer,
      filePath: projectData.file_path || projectData.filePath
    }

    setProjects2((prev) => {
      if (prev.some((p) => p.id_data === newProject.id_data)) return prev;

      return options.prepend ? [newProject, ...prev] : [...prev, newProject];
    });

    window.dispatchEvent(new CustomEvent("projectAdded", { detail: newProject }))
    return newProject
  }

  const upsertProjectFromExternal = (
    projectData: ExternalProjectData,
    options: AddProjectOptions = {},
  ) => {
    const newProject: Project = {
      id: projectData.id_data,
      title: projectData.title,
      description: projectData.description,
      category: projectData.category,
      thumbnail: projectData.thumbnail || `/placeholder.svg?height=300&width=400&text=${encodeURIComponent(projectData.title)}`,
      rating: projectData.rating || 5.0,
      tags: projectData.tags || [],
      author: projectData.author || "Usuário Externo",
      status: projectData.status || "active",
      createdAt: projectData.createdAt,
      sport_id: projectData.sport_id || "",
      svg_path: projectData.svg_path || "",
      id_data: projectData.id_data,
      shared: projectData.shared,
      body_state: projectData.body_state,
      socks_state: projectData.socks_state,
      up_state: projectData.up_state,
      down_state: projectData.down_state,
      clone_state: projectData.clone_state,
      images: projectData.images,
      inside_color: projectData.inside_color,
      up_state2: projectData.up_state2,
      collar: projectData.collar,
      productionOrder: projectData.productionOrder,
      designer: projectData.designer,
      filePath: projectData.file_path,
    }
    setProjects((prev) => {
      const exists = prev.some((p) => p.id_data === newProject.id_data)
      if (exists) {
        return prev.map((p) => p.id_data === newProject.id_data ? newProject : p)
      }
      return options.prepend ? [newProject, ...prev] : [...prev, newProject]
    })
    window.dispatchEvent(new CustomEvent("projectAdded", { detail: newProject }))
    return newProject
  }

  // Expor API globalmente para scripts externos
  useEffect(() => {
    const globalAPI = {
      // Adicionar um projeto
      addProject: (projectData: ExternalProjectData, options?: AddProjectOptions) => {
        return addProjectFromExternal(projectData, options)
      },

      // Adicionar um projeto2
      addProject2: (projectData: ExternalProjectData, options?: AddProjectOptions) => {
        return addProjectFromExternal2(projectData, options)
      },

      // Inserir ou atualizar projeto (upsert) — substitui se já existir pelo id_data
      upsertProject: (projectData: ExternalProjectData, options?: AddProjectOptions) => {
        return upsertProjectFromExternal(projectData, options)
      },


      // Adicionar múltiplos projetos
      addMultipleProjects: (projectsData: ExternalProjectData[]) => {
        //return projectsData.map((projectData) => addProjectFromExternal(projectData))
      },

      // Obter todos os projetos
      getAllProjects: () => {
        return projectsRef.current
      },

      // Obter projeto por ID
      getProjectById: (id: number) => {
        return projectsRef.current.find((p) => p.id === id)
      },

      // Obter contagem de projetos
      getProjectCount: () => {
        return projectsRef.current.length
      },

      // Filtrar projetos por categoria
      getProjectsByCategory: (category: string) => {
        return projectsRef.current.filter((p) => p.category === category)
      },

      // Buscar projetos por termo
      searchProjects: (term: string) => {
        return projectsRef.current.filter(
          (p) =>
            p.title.toLowerCase().includes(term.toLowerCase()) ||
            p.description.toLowerCase().includes(term.toLowerCase()),
        )
      },

      // Remover projeto
      removeProject: (id: number) => {
        setProjects((prev) => prev.filter((p) => p.id !== id))
        window.dispatchEvent(new CustomEvent("projectRemoved", { detail: { id } }))
      },

      // Atualizar projeto
      updateProject: (id: number, updates: Partial<ExternalProjectData>) => {
        setProjects((prev) => prev.map((p) => (p.id === id ? { ...p, ...updates } : p)))
        window.dispatchEvent(new CustomEvent("projectUpdated", { detail: { id, updates } }))
      },

      // Salvar projeto atual
      saveCurrentProject: (name: string) => {
        saveProject(name)
      },

      // Obter projetos salvos
      getSavedProjects: () => {
        return savedProjects
      },

      // New: Functions to manage dynamic menu items
      addDynamicMenuItem: (item: DynamicItens) => {
        setGlobalDynamicMenuItems((prev) => [...prev, item])
      },
      addMultipleDynamicMenuItems: (items: DynamicItens[]) => {
        setGlobalDynamicMenuItems((prev) => [...prev, ...items])
      },
      clearDynamicMenuItems: () => {
        setGlobalDynamicMenuItems([])
      },
      // New: Expose Lucide React icons
      icons: {
        ArrowLeft,
        Package,
        MoreVertical,
        Edit,
        Copy,
        Trash2,
        View,
        Share,
        Home,
        Search,
        Library,
        Heart,
        Settings,
        User,
        Play,
        Info,
        Plus,
        Star,
        X,
        Code,
        Save,
        LogOut,
        Upload,
        Shirt,
        Languages,
        ImageIcon,
        Palette,
        Scissors,
        Box,
        Type,
        Folder,
      },
    }

      // Expor API globalmente
      ; (window as any).CatalogAPI = globalAPI

    // Cleanup
    return () => {
      delete (window as any).CatalogAPI
      delete (window as any).catalogProjects
    }
  }, [savedProjects, globalDynamicMenuItems]) // Add globalDynamicMenuItems to dependencies

  // Função de comparação para ordenação
  const compareProjects = (a: Project, b: Project) => {
    let valA: any = a[sortField] ?? ""
    let valB: any = b[sortField] ?? ""
    if (sortField === "createdAt") {
      valA = valA ? new Date(valA).getTime() : 0
      valB = valB ? new Date(valB).getTime() : 0
    } else if (sortField === "id_data") {
      valA = Number(valA)
      valB = Number(valB)
    } else {
      valA = String(valA).toLowerCase()
      valB = String(valB).toLowerCase()
    }
    if (valA < valB) return sortDirection === "asc" ? -1 : 1
    if (valA > valB) return sortDirection === "asc" ? 1 : -1
    return 0
  }

  // Filtrar projetos por categoria, busca e filtros avançados
  const filteredProjects = projects
    .filter((project) => {
      const matchesCategory = selectedCategory === "" || project.category === selectedCategory
      const matchesSearch =
        searchTerm === "" ||
        project.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        project.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        project.tags?.some((tag) => tag.toLowerCase().includes(searchTerm.toLowerCase())) ||
        String(project.id_data).includes(searchTerm) ||
        (project.productionOrder ?? "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (project.designer ?? "").toLowerCase().includes(searchTerm.toLowerCase())
      const matchesName = filterName === "" || project.title.toLowerCase().includes(filterName.toLowerCase())
      const matchesDesigner = filterDesigner === "" || (project.designer ?? "").toLowerCase().includes(filterDesigner.toLowerCase())
      const matchesId = filterId === "" || String(project.id_data).includes(filterId)
      const matchesOP = filterOP === "" || (project.productionOrder ?? "").toLowerCase().includes(filterOP.toLowerCase())
      const projectDate = project.createdAt ? new Date(project.createdAt) : null
      const matchesDateFrom = filterDateFrom === "" || (projectDate !== null && projectDate >= new Date(filterDateFrom))
      const matchesDateTo = filterDateTo === "" || (projectDate !== null && projectDate <= new Date(filterDateTo + "T23:59:59"))
      return matchesCategory && matchesSearch && matchesName && matchesDesigner && matchesId && matchesOP && matchesDateFrom && matchesDateTo
    })
    .sort(compareProjects)

  const filteredProjects2 = projects2
    .filter((project) => {
      const matchesCategory = selectedCategory === "" || project.category === selectedCategory
      const matchesSearch =
        searchTerm === "" ||
        project.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        project.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        project.tags?.some((tag) => tag.toLowerCase().includes(searchTerm.toLowerCase())) ||
        String(project.id_data).includes(searchTerm) ||
        (project.productionOrder ?? "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (project.designer ?? "").toLowerCase().includes(searchTerm.toLowerCase())
      const matchesName = filterName === "" || project.title.toLowerCase().includes(filterName.toLowerCase())
      const matchesDesigner = filterDesigner === "" || (project.designer ?? "").toLowerCase().includes(filterDesigner.toLowerCase())
      const matchesId = filterId === "" || String(project.id_data).includes(filterId)
      const matchesOP = filterOP === "" || (project.productionOrder ?? "").toLowerCase().includes(filterOP.toLowerCase())
      const projectDate = project.createdAt ? new Date(project.createdAt) : null
      const matchesDateFrom = filterDateFrom === "" || (projectDate !== null && projectDate >= new Date(filterDateFrom))
      const matchesDateTo = filterDateTo === "" || (projectDate !== null && projectDate <= new Date(filterDateTo + "T23:59:59"))
      return matchesCategory && matchesSearch && matchesName && matchesDesigner && matchesId && matchesOP && matchesDateFrom && matchesDateTo
    })
    .sort(compareProjects)

  // Reset visible count when filters change
  useEffect(() => {
    setVisibleCount(PROJECT_BATCH)
  }, [searchTerm, selectedCategory, filterName, filterDesigner, filterId, filterOP, filterDateFrom, filterDateTo, sortField, sortDirection, projects.length])

  useEffect(() => {
    setVisibleCount2(PROJECT_BATCH)
  }, [searchTerm, selectedCategory, filterName, filterDesigner, filterId, filterOP, filterDateFrom, filterDateTo, sortField, sortDirection, projects2.length])

  // IntersectionObserver for infinite scroll (projects-all)
  useEffect(() => {
    const sentinel = sentinelRef.current
    if (!sentinel) return
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && visibleCount < filteredProjects.length) {
          setVisibleCount((prev) => Math.min(prev + PROJECT_BATCH, filteredProjects.length))
        }
      },
      { rootMargin: "400px" }
    )
    observer.observe(sentinel)
    return () => observer.disconnect()
  }, [visibleCount, filteredProjects.length])

  // IntersectionObserver for infinite scroll (projects-all2)
  useEffect(() => {
    const sentinel = sentinelRef2.current
    if (!sentinel) return
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && visibleCount2 < filteredProjects2.length) {
          setVisibleCount2((prev) => Math.min(prev + PROJECT_BATCH, filteredProjects2.length))
        }
      },
      { rootMargin: "400px" }
    )
    observer.observe(sentinel)
    return () => observer.disconnect()
  }, [visibleCount2, filteredProjects2.length])

  const visibleProjects = filteredProjects.slice(0, visibleCount)
  const visibleProjects2 = filteredProjects2.slice(0, visibleCount2)

  // Deletar projeto
  const deleteProject = (id: number, idData: number, path: string) => {
    if (window.confirm("Apagar Projeto? Essa ação não poderá ser desfeita!")) {
      setProjects((prev) => prev.filter((p) => p.id !== id))
      deleteProjectAPI(idData, path)
    }
  }

  // ── Bulk selection handlers ──
  const toggleSelect = (id: number) => {
    setSelectedIds((prev) => {
      const next = new Set(prev)
      if (next.has(id)) next.delete(id)
      else next.add(id)
      return next
    })
  }

  const selectAll = () => {
    const list = activeView === "projects-all2" ? filteredProjects2 : filteredProjects
    setSelectedIds(new Set(list.map((p) => p.id)))
  }

  const deselectAll = () => setSelectedIds(new Set())

  const deleteSelected = () => {
    const list = activeView === "projects-all2" ? filteredProjects2 : filteredProjects
    const toDelete = list.filter((p) => selectedIds.has(p.id))
    if (toDelete.length === 0) return
    if (!window.confirm(`Apagar ${toDelete.length} projeto(s)? Essa ação não poderá ser desfeita!`)) return

    toDelete.forEach((p) => deleteProjectAPI(p.id_data, p.svg_path))
    setProjects((prev) => prev.filter((p) => !selectedIds.has(p.id)))
    setProjects2((prev) => prev.filter((p) => !selectedIds.has(p.id)))
    setSelectedIds(new Set())
  }

  // Cria uma pasta e adiciona os projetos selecionados nela
  const [folderPickerOpen, setFolderPickerOpen] = useState(false)
  const [folderList, setFolderList] = useState<any[]>([])
  const [pickedFolderId, setPickedFolderId] = useState<string>("")
  const [mode, setMode] = useState<"new" | "existing" | "sub">("new")
  const [newFolderName, setNewFolderName] = useState("")

  const createFolderWithSelected = async () => {
    const ids = Array.from(selectedIds)
    if (ids.length === 0) return
    try {
      // Apenas pastas PRINCIPAIS (raiz) para evitar nomes repetidos de subpastas
      const { data } = await supabase.from("folders").select("id,name,projectIds,parentId").is("parentId", null).order("name")
      setFolderList(data || [])
    } catch (e) {
      console.error("Erro ao listar pastas:", e)
      setFolderList([])
    }
    setPickedFolderId("")
    setNewFolderName("")
    setMode("new")
    setFolderPickerOpen(true)
  }

  // Grava os projetos na pasta escolhida segundo o modo (1: nova, 2: existente, 3: subpasta)
  const submitFolderChoice = async () => {
    const ids = Array.from(selectedIds)
    if (ids.length === 0) return

    let targetId = ""
    let createdNew = false

    if (mode === "new") {
      const name = (newFolderName || "").trim()
      if (!name) { (window as any)["toast"]("Informe o nome da pasta!", "info"); return }
      const folderData = await saveFolder(name)
      if (!folderData || !folderData.id) { (window as any)["toast"]("Erro ao criar pasta!", "info"); return }
      targetId = String(folderData.id)
      createdNew = true
    } else if (mode === "sub") {
      const name = (newFolderName || "").trim()
      if (!name) { (window as any)["toast"]("Informe o nome da subpasta!", "info"); return }
      if (!pickedFolderId) { (window as any)["toast"]("Escolha a pasta onde criar a subpasta!", "info"); return }
      const folderData = await saveFolder(name, pickedFolderId)
      if (!folderData || !folderData.id) { (window as any)["toast"]("Erro ao criar subpasta!", "info"); return }
      targetId = String(folderData.id)
      createdNew = true
    } else { // existing
      if (!pickedFolderId) { (window as any)["toast"]("Escolha a pasta!", "info"); return }
      targetId = pickedFolderId
    }

    // projeto(s) final para a pasta (mescla com o que a pasta já tiver, sem duplicar)
    let nextIds = ids
    if (!createdNew) {
      const f = folderList.find((x) => String(x.id) === targetId)
      let existing: any[] = []
      if (Array.isArray(f?.projectIds)) existing = f.projectIds
      else if (typeof f?.projectIds === "string") { try { existing = JSON.parse(f.projectIds) || [] } catch { existing = [] } }
      nextIds = Array.from(new Set([...existing, ...ids]))
    }

    console.log("[addToFolder] mode:", mode, "| targetId:", targetId, "| nextIds:", nextIds)

    await updateFolderProjects(targetId, JSON.stringify(nextIds))

    const folderApi = (window as any)?.folderAPI
    if (folderApi?.updateFolder) {
      if (createdNew) {
        folderApi.addFolder({
          id: targetId,
          name: (newFolderName || "").trim() || "Pasta",
          projectIds: nextIds,
          parentId: mode === "sub" ? pickedFolderId : null,
        })
      } else {
        folderApi.updateFolder(targetId, { projectIds: nextIds })
      }
      folderApi.navigate?.(targetId)
    }

    (window as any)["toast"](`${ids.length} projeto(s) adicionado(s)!`, "info")
    setSelectedIds(new Set())
    setFolderPickerOpen(false)
  }

  const isAllSelected = () => {
    const list = activeView === "projects-all2" ? filteredProjects2 : filteredProjects
    return list.length > 0 && list.every((p) => selectedIds.has(p.id))
  }

  const handlecategory = (style: string) => {

    setCategory(style);

    const selectedCat = categories.find(cat => cat.id === style) as any;

    if (style == "todos") {
      $(".project-shared").css("visibility", "hidden");
      $(".project-list").parent().css("display", "block");
    } else {
      $(".project-shared").css("visibility", "visible");
      $(".project-list").parent().css("display", "none");

      for (var i = 0; i < (window as any).categoriesLoaded[selectedCat.index].projectIds.length; i++) {
        $("#project-" + (window as any).categoriesLoaded[selectedCat.index].projectIds[i]).parent().css("display", "block");
      }
    }
  };

  (window as any)['setCategoriesProjects'] = function (array: any) {
    setCategories(array)
  }

  const handleShareAll = function () {

    if ((window as any).dataArray) {

      if ((window as any).dataArray.length > 0) {
        const link = window.location.origin + "?i=" + (window as any).dataArray[(window as any).dataArray.length - 1].id + "&a=all";

        navigator.clipboard.writeText(link)
          .then(() => {
            (window as any)['toast']("Link copiado!", "info")
          })
          .catch(err => {
            console.error("Erro ao copiar: ", err);
          });
      } else {
        (window as any)['toast']("Nenhum projeto para compartilhar!", "info")
      }

    } else {
      (window as any)['toast']("Nenhum projeto para compartilhar!", "info")
    }

  }

  const handleView = function (id: string) {
    $(".projects-parent").addClass("hidden").css("display", "")
    $("#" + id).removeClass("hidden")

    $(".projects-parent-options").css("border", "none")
    $("#" + id + "-option").css("border", "2px solid green")
    setActiveView(id)
    setSelectedIds(new Set())
  }

  let projectsNew = projects.map(item => ({
    id: String(item.id),
    name: item.title ?? "",
    thumbnail: item.thumbnail ?? "",
    createdAt: item.createdAt ?? "",
    description: item.description ?? ""
  }));

  //
  useEffect(() => {
    loadTables();
  }, []);

  const loadTables = async () => {
    try {
      const res = await supbaseManager("get", "color-tables", null, getUserId())

      if (res.length == 0) {
        setTables([])
        return
      }

      var res2 = [] as any;

      for (var i = 0; i < res.length; i++) {
        const content = JSON.parse(res[i].content);
        content.id = res[i].id.toString();
        res2.push(content);
      }

      // ⚠️ importante: converter datas
      const parsed = res2.map((t: ColorTable) => ({
        ...t,
        createdAt: new Date(t.createdAt),
        updatedAt: new Date(t.updatedAt),
      }));

      var array = [] as any;

      for (var i = 0; i < parsed.length; i++) {
        array.push(createColorOption(parsed[i].id, parsed[i].name));
      }

      customColors = addColorOptions([], array)

      setTables(parsed)
    } catch (err) {
      console.error(err)
    }
  }


  return (
    <SidebarProvider>
      <Categoires></Categoires>
      <div className="hidden text-primary" id="form-iframe">
        <UniformForm></UniformForm>
      </div>

      <div className="hidden text-primary" id="landing-iframe">
        <div className="z-[1000000000000000000] overflow-y-auto max-w-full h-full fixed">
          <JerseyBirdPage initialConfig={null} onConfigChange={null} />
        </div>
      </div>

      <AppSidebar
        selectedCategory={selectedCategory}
        onCategoryChange={setSelectedCategory}
        projects={projects}
        onSaveProject={saveProject}
        onOpenResourceModal={openResourceModal}
        onOpenSellers={() => setIsModalOpen(true)}
        onOpenStoreData={() => setIsClientDataModalOpen(true)}
        onShareForm={() => setOpen2(true)}
        isVendedor={tempClientData.role === "vendedor"}
      />
      <SidebarInset>
        <header className="flex h-14 shrink-0 items-center gap-2 border-b px-4 w-full">
          <SidebarTrigger className="-ml-1" />

          {/* Tabs centralizadas */}
          <div className="flex-1 flex justify-center">
            <div className="flex rounded-lg overflow-hidden border border-border">
              <button
                id="projects-all-option"
                className="projects-parent-options px-5 py-1.5 text-sm font-medium cursor-pointer transition-colors hover:bg-muted"
                onClick={() => handleView("projects-all")}
              >Meus Projetos</button>
              <button
                id="projects-all2-option"
                className="projects-parent-options px-5 py-1.5 text-sm font-medium cursor-pointer transition-colors border-l border-border hover:bg-muted"
                onClick={() => handleView("projects-all2")}
              >Projetos da Loja</button>
              <button
                id="projects-folders-option"
                className="projects-parent-options px-5 py-1.5 text-sm font-medium cursor-pointer transition-colors border-l border-border hover:bg-muted"
                onClick={() => handleView("projects-folders")}
              >Pastas</button>
            </div>
          </div>

          {/* Direita: Busca + Filtros + Voltar */}
          <div className="flex items-center gap-2">
            <div className="relative">
              <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
              <Input
                placeholder="Buscar por nome, OP, designer, ID..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-8 w-64"
              />
            </div>


            <Button
              size="sm"
              variant={showAdvancedFilters ? "default" : "outline"}
              onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
              title="Filtros avançados"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" /></svg>
            </Button>

            {/* Ordenação */}
            <Select value={sortField} onValueChange={(v) => setSortField(v as any)}>
              <SelectTrigger className="w-36 h-8 text-xs">
                <SelectValue placeholder="Ordenar por" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="createdAt">Data</SelectItem>
                <SelectItem value="title">Nome</SelectItem>
                <SelectItem value="designer">Designer</SelectItem>
                <SelectItem value="id_data">ID</SelectItem>
                <SelectItem value="productionOrder">OP</SelectItem>
              </SelectContent>
            </Select>

            <Button
              size="sm"
              variant="outline"
              className="px-2"
              title={sortDirection === "asc" ? "Crescente" : "Decrescente"}
              onClick={() => setSortDirection(d => d === "asc" ? "desc" : "asc")}
            >
              {sortDirection === "asc"
                ? <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="19" x2="12" y2="5" /><polyline points="5 12 12 5 19 12" /></svg>
                : <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19" /><polyline points="19 12 12 19 5 12" /></svg>
              }
            </Button>

            <Button size="sm" variant="outline" id="close-panel" className="ml-1">
              Voltar
            </Button>
          </div>

          {/* Dialogs mantidos (sem trigger visível aqui, acionados pelo sidebar) */}
          <div className="hidden">
            <div>
              <Button onClick={() => setOpen2(true)} className="view-share">Compartilhar Formulário</Button>
              <OptionsControlModal
                open={open2}
                onOpenChange={setOpen2}
                initialConfig={savedConfig2}
                onSave={handleSave2}
                colorOptions={customColors}
              />
            </div>
            <Dialog open={isClientDataModalOpen} onOpenChange={(open) => { setIsClientDataModalOpen(open); if (open) loadTeamMembers() }}>
              <DialogTrigger asChild>
                <Button size="sm" variant="outline" className="text-primary">
                  <User className="h-4 w-4 mr-2" />
                  Dados da Loja
                </Button>
              </DialogTrigger>
              <DialogContent className="sm:max-w-md h-[95%] overflow-y-scroll">
                <DialogHeader>
                  <DialogTitle>Dados do Cliente</DialogTitle>
                </DialogHeader>
                <div className="space-y-4 py-4">


                  <div className="space-y-2 flex flex-col">
                    <Label htmlFor="client-name">Nome da Empresa</Label>
                    <Input
                      required
                      id="client-name"
                      type="text"
                      value={tempClientData.name}
                      onChange={(e) => setTempClientData({ ...tempClientData, name: e.target.value })}
                    />
                  </div>

                  <div className="space-y-2 flex flex-col">
                    <Label htmlFor="client-name">CNPJ/NIF</Label>
                    <Input
                      required
                      id="client-cnpj"
                      type="text"
                      value={tempClientData.cnpj}
                      onChange={(e) => setTempClientData({ ...tempClientData, cnpj: e.target.value })}
                    />
                  </div>

                  <div className="space-y-2 flex flex-col">
                    <Label htmlFor="client-name">Endereço</Label>
                    <Input
                      required
                      id="client-end"
                      type="text"
                      value={tempClientData.end}
                      onChange={(e) => setTempClientData({ ...tempClientData, end: e.target.value })}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="client-phone">Teleforne</Label>
                    <Input
                      required
                      id="client-phone"
                      type="tel"
                      value={tempClientData.phone}
                      onChange={(e) => setTempClientData({ ...tempClientData, phone: e.target.value })}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="client-whatsapp">Whatsapp</Label>
                    <Input
                      required
                      id="client-whatsapp"
                      type="tel"
                      value={tempClientData.whatsapp}
                      onChange={(e) => setTempClientData({ ...tempClientData, whatsapp: e.target.value })}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="client-email">Email</Label>
                    <Input
                      required
                      id="client-email"
                      type="email"
                      value={tempClientData.email}
                      onChange={(e) => setTempClientData({ ...tempClientData, email: e.target.value })}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="client-site">Site</Label>
                    <Input
                      required
                      id="client-site"
                      type="text"
                      value={tempClientData.site}
                      onChange={(e) => setTempClientData({ ...tempClientData, site: e.target.value })}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="client-instagram">Instagram</Label>
                    <Input
                      required
                      id="client-instagram"
                      type="text"
                      value={tempClientData.instagram}
                      onChange={(e) => setTempClientData({ ...tempClientData, instagram: e.target.value })}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="client-horario">Horário de Atendimento</Label>
                    <Input
                      required
                      id="client-horario"
                      type="text"
                      value={tempClientData.horario}
                      onChange={(e) => setTempClientData({ ...tempClientData, horario: e.target.value })}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="client-pedido_min">Pedido Mínimo</Label>
                    <Input
                      required
                      id="client-pedido_min"
                      type="text"
                      value={tempClientData.pedido_min}
                      onChange={(e) => setTempClientData({ ...tempClientData, pedido_min: e.target.value })}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="client-prazo">Prazo de Produção</Label>
                    <Input
                      required
                      id="client-prazo"
                      type="text"
                      value={tempClientData.prazo}
                      onChange={(e) => setTempClientData({ ...tempClientData, prazo: e.target.value })}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="client-pagamento">Formas de pagamento (Separar por vírgula)</Label>
                    <Input
                      required
                      id="client-pagamento"
                      type="text"
                      value={tempClientData.pagamento}
                      onChange={(e) => setTempClientData({ ...tempClientData, pagamento: e.target.value })}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="client-moeda">Moeda</Label>
                    <Input
                      required
                      id="client-moeda"
                      type="text"
                      value={"R$"}
                      onChange={(e) => setTempClientData({ ...tempClientData, instagram: e.target.value })}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="client-description">Menssagem Whatsapp</Label>
                    <textarea
                      required
                      id="client-description"
                      placeholder="Digite uma descrição sobre o cliente ou empresa"
                      value={tempClientData.description}
                      onChange={(e) => setTempClientData({ ...tempClientData, description: e.target.value })}
                      className="bg-background w-full min-h-[100px] px-3 py-2 border border-input rounded-md text-sm resize-none focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
                    />
                  </div>

                  <div className="space-y-2 border-t pt-4">
                    <Label>Meu cargo</Label>
                    <p className="text-xs text-muted-foreground">
                      Escolha seu cargo. Gestores veem todos os briefings da organização e têm acesso total.
                      Vendedores atribuem briefings aos designers. Designers executam os briefings atribuídos.
                    </p>
                    <Input
                      placeholder="Seu nome"
                      value={tempClientData.user_name}
                      onChange={(e) => setTempClientData({ ...tempClientData, user_name: e.target.value })}
                    />
                    <Select value={tempClientData.role} onValueChange={(v) => setTempClientData({ ...tempClientData, role: v as "designer" | "vendedor" | "gestao" })}>
                      <SelectTrigger>
                        <SelectValue placeholder="Selecionar cargo" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="gestao">Gestão</SelectItem>
                        <SelectItem value="vendedor">Vendedor</SelectItem>
                        <SelectItem value="designer">Designer</SelectItem>
                      </SelectContent>
                    </Select>

                    {teamMembers.length > 0 && (
                      <div className="pt-2">
                        <p className="text-xs text-muted-foreground mb-1.5">Equipe (mesmo e-mail principal):</p>
                        <div className="space-y-1.5">
                          {teamMembers.map((m) => (
                            <div key={m.id} className="flex items-center justify-between gap-2 rounded-md border px-3 py-2 text-sm">
                              <p className="font-medium truncate min-w-0">{m.name}</p>
                              <span className={`flex-shrink-0 rounded-full px-2 py-0.5 text-[10px] font-medium ${m.role === "designer" ? "bg-purple-500/20 text-purple-500" : m.role === "gestao" ? "bg-amber-500/20 text-amber-500" : "bg-blue-500/20 text-blue-500"}`}>
                                {m.role === "designer" ? "Designer" : m.role === "gestao" ? "Gestão" : "Vendedor"}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="client-logo">Logo</Label>
                    <div className="flex flex-col items-center gap-4">
                      {tempClientData.logo && (
                        <div className="w-24 h-24 relative border rounded-lg overflow-hidden flex items-center">
                          <img
                            src={tempClientData.logo || "/placeholder.svg"}
                            alt="Logo do cliente"
                            className="object-contain w-full h-full"
                          />
                        </div>
                      )}
                      <div className="flex items-center gap-2">
                        <Input
                          required
                          id="client-logo"
                          type="file"
                          accept="image/*"
                          onChange={handleLogoUpload}
                          className="hidden"
                        />
                        <Button
                          type="button"
                          variant="outline"
                          onClick={() => document.getElementById("client-logo")?.click()}
                        >
                          <Upload className="h-4 w-4 mr-2" />
                          {tempClientData.logo ? "Alterar Logo" : "Adicionar Logo"}
                        </Button>
                      </div>
                    </div>
                  </div>

                  {/**<div className="space-y-2">
                      <Label htmlFor="client-banner_print_top">Banner Print Superior</Label>
                      <div className="flex flex-col items-center gap-4">
                        {tempClientData.banner_print_top && (
                          <div className="w-24 h-24 relative border rounded-lg overflow-hidden flex items-center">
                            <img
                              src={tempClientData.banner_print_top || "/placeholder.svg"}
                              alt=""
                              className="object-contain w-full h-full"
                            />
                          </div>
                        )}
                        <div className="flex items-center gap-2">
                          <Input
                            required
                            id="client-banner_print_top"
                            type="file"
                            accept="image/*"
                            onChange={handleBannerPrintTopUpload}
                            className="hidden"
                          />
                          <Button
                            type="button"
                            variant="outline"
                            onClick={() => document.getElementById("client-banner_print_top")?.click()}
                          >
                            <Upload className="h-4 w-4 mr-2" />
                            {tempClientData.banner_print_top ? "Alterar" : "Adicionar"}
                          </Button>
                        </div>
                      </div>
                    </div>

                    <div className="space-y-2">
                      <Label htmlFor="client-banner_print_top">Banner Print Inferior</Label>
                      <div className="flex flex-col items-center gap-4">
                        {tempClientData.banner_print_bottom && (
                          <div className="w-24 h-24 relative border rounded-lg overflow-hidden flex items-center">
                            <img
                              src={tempClientData.banner_print_bottom || "/placeholder.svg"}
                              alt=""
                              className="object-contain w-full h-full"
                            />
                          </div>
                        )}
                        <div className="flex items-center gap-2">
                          <Input
                            required
                            id="client-banner_print_bottom"
                            type="file"
                            accept="image/*"
                            onChange={handleBannerPrintBottomUpload}
                            className="hidden"
                          />
                          <Button
                            type="button"
                            variant="outline"
                            onClick={() => document.getElementById("client-banner_print_bottom")?.click()}
                          >
                            <Upload className="h-4 w-4 mr-2" />
                            {tempClientData.banner_print_bottom ? "Alterar" : "Adicionar"}
                          </Button>
                        </div>
                      </div>
                    </div> */}

                  {/**<div className="space-y-2">
                      <Label htmlFor="client-banner_print_top">Banner Catálogo Superior</Label>
                      <div className="flex flex-col items-center gap-4">
                        {tempClientData.catalog_banner_top && (
                          <div className="w-24 h-24 relative border rounded-lg overflow-hidden flex items-center">
                            <img
                              src={tempClientData.catalog_banner_top || "/placeholder.svg"}
                              alt=""
                              className="object-contain w-full h-full"
                            />
                          </div>
                        )}
                        <div className="flex items-center gap-2">
                          <Input
                            required
                            id="client-catalog_banner_top"
                            type="file"
                            accept="image/*"
                            onChange={handleBannerCatalogTopUpload}
                            className="hidden"
                          />
                          <Button
                            type="button"
                            variant="outline"
                            onClick={() => document.getElementById("client-catalog_banner_top")?.click()}
                          >
                            <Upload className="h-4 w-4 mr-2" />
                            {tempClientData.catalog_banner_top ? "Alterar" : "Adicionar"}
                          </Button>
                        </div>
                      </div>
                    </div> */}

                </div>
                <div className="flex justify-end gap-2">
                  <Button variant="outline" onClick={handleCancelClientData}>
                    Cancelar
                  </Button>
                  <Button onClick={handleSaveClientData} disabled={!isClientDataValid()}>Salvar</Button>
                </div>
              </DialogContent>
            </Dialog>
          </div>
        </header>

        {/* Painel de filtros avançados */}
        {showAdvancedFilters && (
          <div className="border-b border-border bg-muted/30 px-4 py-3 flex flex-wrap gap-3 items-end">
            <div className="flex flex-col gap-1">
              <label className="text-xs text-muted-foreground font-medium">Nome</label>
              <Input
                placeholder="Filtrar por nome..."
                value={filterName}
                onChange={(e) => setFilterName(e.target.value)}
                className="h-8 w-44 text-xs"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-xs text-muted-foreground font-medium">Designer</label>
              <Input
                placeholder="Filtrar por designer..."
                value={filterDesigner}
                onChange={(e) => setFilterDesigner(e.target.value)}
                className="h-8 w-44 text-xs"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-xs text-muted-foreground font-medium">ID</label>
              <Input
                placeholder="Filtrar por ID..."
                value={filterId}
                onChange={(e) => setFilterId(e.target.value)}
                className="h-8 w-32 text-xs"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-xs text-muted-foreground font-medium">OP</label>
              <Input
                placeholder="Filtrar por OP..."
                value={filterOP}
                onChange={(e) => setFilterOP(e.target.value)}
                className="h-8 w-36 text-xs"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-xs text-muted-foreground font-medium">Data de</label>
              <Input
                type="date"
                value={filterDateFrom}
                onChange={(e) => setFilterDateFrom(e.target.value)}
                className="h-8 w-36 text-xs"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-xs text-muted-foreground font-medium">Data até</label>
              <Input
                type="date"
                value={filterDateTo}
                onChange={(e) => setFilterDateTo(e.target.value)}
                className="h-8 w-36 text-xs"
              />
            </div>
            <Button
              size="sm"
              variant="ghost"
              className="h-8 text-xs text-muted-foreground"
              onClick={() => {
                setFilterName("")
                setFilterDesigner("")
                setFilterId("")
                setFilterOP("")
                setFilterDateFrom("")
                setFilterDateTo("")
                setSearchTerm("")
              }}
            >
              <X className="h-3 w-3 mr-1" />
              Limpar filtros
            </Button>
          </div>
        )}

        {/* ── Bulk action toolbar ── */}
        {selectedIds.size > 0 && tempClientData.role !== "vendedor" && (
          <div className="flex items-center gap-3 px-4 py-2 bg-primary/10 border-b border-primary/20">
            <span className="text-sm font-medium text-primary">
              {selectedIds.size} selecionado(s)
            </span>
            <Button size="sm" variant="ghost" className="h-7 text-xs" onClick={selectAll}>
              <Check className="h-3 w-3 mr-1" /> Todos
            </Button>
            <Button size="sm" variant="ghost" className="h-7 text-xs" onClick={deselectAll}>
              <X className="h-3 w-3 mr-1" /> Nenhum
            </Button>
            <Button size="sm" variant="secondary" className="h-7 text-xs" onClick={createFolderWithSelected}>
              <Folder className="h-3 w-3 mr-1" /> Criar pasta e adicionar ({selectedIds.size})
            </Button>
            <Button size="sm" variant="destructive" className="h-7 text-xs" onClick={deleteSelected}>
              <Trash2 className="h-3 w-3 mr-1" /> Apagar ({selectedIds.size})
            </Button>
          </div>
        )}

        {tempClientData.role !== "vendedor" && (
          <main className="flex-1 p-6 overflow-y-scroll">

            <div className="z-10 fixed w-full h-auto top-0 left-0 bg-red">
              {/**<CategoryModal isOpen={isModalOpenCat} onClose={() => setIsModalCatOpen(false)} /> */}
              <CategoryManager isOpen={isModalOpenCat} onClose={() => setIsModalCatOpen(false)} />
            </div>

            <SellerManagementModal
              open={isModalOpen}
              onOpenChange={setIsModalOpen}
              sellers={sellers}
              onAddSeller={handleAddSeller}
              onRemoveSeller={handleRemoveSeller}
            />

            <div id="projects-folders" className="projects-parent hidden w-full">
              <div className="flex w-full">
                <FolderManager project2={projects} />
              </div>
            </div>

            <div id="projects-all" className="projects-parent">
              <p className="text-sm text-muted-foreground mb-4">{activeView === "projects-all2" ? filteredProjects2.length : filteredProjects.length} projeto(s) encontrado(s)</p>

              {filteredProjects.length === 0 ? (
                <div className="text-center py-0 justify-center w-full flex h-[80%] items-center">
                  <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" ></Loader2>
                </div>
              ) : (
                <>
                <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
                  {visibleProjects.map((project, idx) => (
                    <ProjectCard
                      key={`p1-${project.id_data}-${idx}`}
                      project={project}
                      onDelete={deleteProject}
                      dynamicMenuItems={globalDynamicMenuItems}
                      selected={selectedIds.has(project.id)}
                      onToggle={toggleSelect}
                    />
                  ))}
                </div>
                <div ref={sentinelRef} className="h-4" />
                {visibleCount < filteredProjects.length && (
                  <div className="flex justify-center py-4">
                    <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
                  </div>
                )}
                </>
              )}
            </div>

            <div id="projects-all2" className="projects-parent hidden">


              {filteredProjects2.length === 0 ? (
                <div className="text-center py-0 justify-center w-full flex h-[80%] items-center">
                  <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" ></Loader2>
                </div>
              ) : (
                <>
                <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
                  {visibleProjects2.map((project, idx) => (
                    <ProjectCard
                      key={`p2-${project.id_data}-${idx}`}
                      project={project}
                      onDelete={deleteProject}
                      dynamicMenuItems={globalDynamicMenuItems}
                      selected={selectedIds.has(project.id)}
                      onToggle={toggleSelect}
                    />
                  ))}
                </div>
                <div ref={sentinelRef2} className="h-4" />
                {visibleCount2 < filteredProjects2.length && (
                  <div className="flex justify-center py-4">
                    <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
                  </div>
                )}
                </>
              )}
            </div>

          </main>
        )}
      </SidebarInset>

      {/* Modal de recursos */}
      {activeResourceModal && (
        <ResourceModal
          items={items}
          type={activeResourceModal}
          isOpen={true}
          onClose={closeResourceModal}
          onSave={(data) => saveResource(activeResourceModal, data)}
        />
      )}

      {/* Modal de Catálogos */}
      <CatalogModal isOpen={isCatalogModalOpen} onClose={() => setIsCatalogModalOpen(false)} />

      <div id="modal-color-table" className="bg-background w-full h-full fixed z-[1000] hidden">
        {/* Header */}
        <header className="border-b border-border">
          <div className="container mx-auto px-4 py-6">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div className="flex items-center gap-3">
                <div className="size-10 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Palette className="size-5 text-primary" />
                </div>
                <div>
                  <h1 className="text-xl font-semibold text-foreground">
                    Tabelas de Cores
                  </h1>
                  <p className="text-sm text-muted-foreground">
                    Gerencie suas paletas extraídas de arquivos SVG
                  </p>
                </div>
              </div>

              <div className="w-auto right-5">
                <Button onClick={() => setIsModalOpen2(true)} className="gap-2 m-2">
                  <Plus className="size-4" />
                  Nova Tabela
                </Button>

                <Button id="close-modal-color-table" className="gap-2 m-2">
                  <X className="size-4"></X>
                  Fechar
                </Button>
              </div>

            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="container mx-auto px-4 py-8">
          <ColorTableGrid
            tables={tables}
            onDelete={handleDelete}
            onDuplicate={handleDuplicate}
          />
        </main>

        {/* Modal */}
        <ColorTableModal
          open={isModalOpen2}
          onOpenChange={setIsModalOpen2}
          onSave={handleSave}
        />

        {/* Escolher pasta para os projetos selecionados */}
        <Dialog open={folderPickerOpen} onOpenChange={setFolderPickerOpen}>
          <DialogContent className="sm:max-w-md">
            <DialogHeader>
              <DialogTitle>Adicionar Projetos à Pasta</DialogTitle>
              <DialogDescription>
                {selectedIds.size} projeto(s) selecionado(s). Escolha uma das opções abaixo.
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-3 py-2">
              {/* Opção 1: criar pasta nova */}
              <button
                type="button"
                onClick={() => setMode("new")}
                className={`w-full text-left rounded-lg border p-3 transition-colors ${mode === "new" ? "border-primary bg-primary/5" : "border-border"}`}
              >
                <span className="font-medium">1 - Criar nova pasta com os projetos</span>
              </button>
              {mode === "new" && (
                <Input placeholder="Nome da pasta" value={newFolderName} onChange={(e) => setNewFolderName(e.target.value)} autoFocus />
              )}

              {/* Opção 2: adicionar a uma pasta existente */}
              <button
                type="button"
                onClick={() => setMode("existing")}
                className={`w-full text-left rounded-lg border p-3 transition-colors ${mode === "existing" ? "border-primary bg-primary/5" : "border-border"}`}
              >
                <span className="font-medium">2 - Adicionar em pasta existente</span>
              </button>
              {mode === "existing" && (
                <FolderListPicker list={folderList} picked={pickedFolderId} onPick={setPickedFolderId} />
              )}

              {/* Opção 3: criar subpasta (com os projetos) dentro de existente */}
              <button
                type="button"
                onClick={() => setMode("sub")}
                className={`w-full text-left rounded-lg border p-3 transition-colors ${mode === "sub" ? "border-primary bg-primary/5" : "border-border"}`}
              >
                <span className="font-medium">3 - Criar subpasta com os projetos dentro de uma pasta</span>
              </button>
              {mode === "sub" && (
                <div className="space-y-2">
                  <FolderListPicker list={folderList} picked={pickedFolderId} onPick={setPickedFolderId} />
                  <Input placeholder="Nome da subpasta" value={newFolderName} onChange={(e) => setNewFolderName(e.target.value)} />
                </div>
              )}
            </div>
            <DialogFooter>
              <Button variant="outline" onClick={() => setFolderPickerOpen(false)}>
                Cancelar
              </Button>
              <Button onClick={submitFolderChoice}>
                Adicionar ({selectedIds.size})
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    </SidebarProvider>
  )
}

function FolderListPicker({ list, picked, onPick }: { list: any[]; picked: string; onPick: (id: string) => void }) {
  const byId = new Map(list.map((f) => [String(f.id), f]))
  const pathOf = (f: any) => {
    const parts: string[] = []
    let cur: any = f
    let guard = 0
    while (cur && guard++ < 20) {
      parts.unshift(cur.name)
      cur = cur.parentId ? byId.get(String(cur.parentId)) : null
    }
    return parts.join(" › ")
  }
  return (
    <div className="max-h-48 overflow-y-auto rounded-lg border border-border p-1 space-y-1">
      {list.length === 0 && (
        <p className="px-2 py-3 text-center text-sm text-muted-foreground">Nenhuma pasta ainda.</p>
      )}
      {list.map((f) => (
        <button
          key={f.id}
          type="button"
          onClick={() => onPick(String(f.id))}
          className={`w-full flex items-center justify-between rounded-md px-3 py-2 text-sm transition-colors ${picked === String(f.id) ? "bg-primary/10" : "hover:bg-accent"}`}
        >
          <span className="flex items-center gap-2 min-w-0">
            <Folder className="h-4 w-4 shrink-0" />
            <span className="truncate">{pathOf(f)}</span>
          </span>
          <Check className={`h-4 w-4 shrink-0 ${picked === String(f.id) ? "opacity-100" : "opacity-0"}`} />
        </button>
      ))}
    </div>
  )
}

interface Piece {
  id: string
  name: string
  image: string
  price: number
  sport_id: string
}

interface Catalog {
  id: string
  name: string
  thumbnail: string
  pieces: Piece[]
}

interface CatalogModalProps {
  isOpen: boolean
  onClose: () => void
}

interface ClientData {
  logo: string | null
  description: string
  phone: string
  name: string
  banner_print_top: string | null
  banner_print_bottom: string | null
  catalog_banner_top: string | null
  cnpj: string
  end: string
  email: string
  site: string
  instagram: string
  whatsapp: string
  horario: string
  pedido_min: string
  prazo: string
  pagamento: string
  role: "designer" | "vendedor" | "gestao" | ""
  user_name: string
}

function CatalogModal({ isOpen, onClose }: CatalogModalProps) {

  const [isAddCatalogModalOpen, setIsAddCatalogModalOpen] = useState(false)
  const [selectedCatalog, setSelectedCatalog] = useState<Catalog | null>(null)
  const [newCatalogName, setNewCatalogName] = useState("")

  // Dados de exemplo
  const [catalogs, setCatalogs] = useState<Catalog[]>([
    {
      id: "1",
      name: "Todos",
      thumbnail: "/images/catalog.webp",
      pieces: [],
    },
  ]);

  const catalogsRef = useRef(catalogs);

  useEffect(() => {
    catalogsRef.current = catalogs;
  }, [catalogs]);

  const handleAddCatalog = () => {
    if (newCatalogName.trim()) {

      (window as { [key: string]: any })["CatalogAPI"].addDynamicMenuItem({
        id: Date.now().toString(),
        label: newCatalogName
      });

      const newCatalog: Catalog = {
        id: Date.now().toString(),
        name: newCatalogName,
        thumbnail: "/images/catalog.webp?height=200&width=200",
        pieces: [],
      }
      setCatalogs([...catalogs, newCatalog])
      setNewCatalogName("")
      setIsAddCatalogModalOpen(false)

      const arr = [] as any;
      const json = JSON.stringify(arr);

      registerCatalog(json, newCatalogName);
    }
  }

  (window as { [key: string]: any })["handleAddCatalog"] = async () => {

    // Acumula todos os novos catálogos em um array temporário
    const newCatalogsToAdd: Catalog[] = []
    const apiCatalogs = await getCatalogs() as any;
    for (const apiCatalog of apiCatalogs) {
      // Você pode adicionar lógica aqui para formatar ou validar o catálogo da API
      // Certifique-se de que o ID seja único, se a API não garantir
      const newCatalog: Catalog = {
        id: apiCatalog.id, // Garante um ID único
        name: apiCatalog.name,
        thumbnail: apiCatalog.thumbnail || "/images/catalog.webp?height=200&width=200",
        pieces: JSON.parse(apiCatalog.list),
      }
      newCatalogsToAdd.push(newCatalog);

      (window as { [key: string]: any })["CatalogAPI"].addDynamicMenuItem({
        id: apiCatalog.id,
        label: apiCatalog.name
      });
    }

    // Atualiza o estado `catalogs` UMA VEZ com todos os novos catálogos
    setCatalogs((prevCatalogs) => [...prevCatalogs, ...newCatalogsToAdd])
  }

  const handleCatalogClick = (catalog: Catalog) => {
    setSelectedCatalog(catalog)
  }

  const handleBackToCatalogs = () => {
    setSelectedCatalog(null)
  }

  const handleClose = () => {
    setSelectedCatalog(null)
    setIsAddCatalogModalOpen(false)
    onClose()
  }

  const handleRemovePiece = (pieceId: string) => {
    if (selectedCatalog) {
      const updatedCatalog = {
        ...selectedCatalog,
        pieces: selectedCatalog.pieces.filter((piece) => piece.id !== pieceId),
      }
      setSelectedCatalog(updatedCatalog)
      setCatalogs(catalogs.map((catalog) => (catalog.id === selectedCatalog.id ? updatedCatalog : catalog)))

      setTimeout(() => {
        const updated = catalogsRef.current.find(c => c.id === selectedCatalog.id) as any;

        editCatalog(selectedCatalog.id, JSON.stringify(updated.pieces));

      }, 100);
    }
  }

  const handleShareCatalog = (catalog: Catalog) => {
    // Aqui você pode implementar a lógica de compartilhamento
    // Por exemplo: copiar link, abrir modal de compartilhamento, etc.

    if (catalog.name == "Todos") {
      // Get the text field
      var copyText = (window as { [key: string]: any }).location.host + "?cat=1&id=" + getUserId();
    } else {
      var copyText = (window as { [key: string]: any }).location.host + "?cat=" + catalog.id + "&id=" + getUserId();
    }

    // Copy the text inside the text field
    navigator.clipboard.writeText(copyText);

    // Alert the copied text
    alert("Link copiado com sucesso!");
  }

  const addPieceToCatalog = (register: boolean, catalogId: string, piece: Omit<Piece, "id">) => {

    for (var i = 0; i < catalogs.length; i++) {
      if (catalogs[i].id == catalogId) {
        for (var j = 0; j < catalogs[i].pieces.length; j++) {
          if (catalogs[i].pieces[j].sport_id == piece.sport_id) {
            return;
          }
        }
        break;
      }
    }

    const newPiece: Piece = {
      ...piece,
      id: Date.now().toString() + Math.random().toString(36).substr(2, 9),
    }

    setCatalogs((prevCatalogs) =>
      prevCatalogs.map((catalog) =>
        catalog.id === catalogId ? { ...catalog, pieces: [...catalog.pieces, newPiece] } : catalog,
      ),
    )

    // Se o catálogo selecionado for o mesmo que está sendo atualizado, atualize também
    if (selectedCatalog && selectedCatalog.id === catalogId) {
      setSelectedCatalog((prev) => (prev ? { ...prev, pieces: [...prev.pieces, newPiece] } : null))
    }

    //

    setTimeout(() => {
      if (register) {
        const updated = catalogsRef.current.find(c => c.id === catalogId) as any;

        editCatalog(catalogId, JSON.stringify(updated.pieces));
      }
    }, 100);

    return newPiece.id
  }

  // Função para adicionar múltiplas peças de uma vez
  const addMultiplePiecesToCatalog = (catalogId: string, pieces: Omit<Piece, "id">[]) => {
    const newPieces: Piece[] = pieces.map((piece) => ({
      ...piece,
      id: Date.now().toString() + Math.random().toString(36).substr(2, 9),
    }))

    setCatalogs((prevCatalogs) =>
      prevCatalogs.map((catalog) =>
        catalog.id === catalogId ? { ...catalog, pieces: [...catalog.pieces, ...newPieces] } : catalog,
      ),
    )

    if (selectedCatalog && selectedCatalog.id === catalogId) {
      setSelectedCatalog((prev) => (prev ? { ...prev, pieces: [...prev.pieces, ...newPieces] } : null))
    }

    return newPieces.map((piece) => piece.id)
  }

  // Função para obter todos os catálogos (útil para scripts externos)
  const getAllCatalogs = () => catalogs

  // Função para obter um catálogo específico
  const getCatalogById = (catalogId: string) => catalogs.find((catalog) => catalog.id === catalogId)

  // Adicione este useEffect após as outras funções
  useEffect(() => {
    // Expor funções globalmente para uso em outros scripts
    if (typeof window !== "undefined") {
      ; (window as any).catalogFunctions = {
        addPieceToCatalog,
        addMultiplePiecesToCatalog,
        getAllCatalogs,
        getCatalogById,
      }
    }

    return () => {
      // Cleanup ao desmontar o componente
      if (typeof window !== "undefined") {
        delete (window as any).catalogFunctions
      }
    }
  }, [catalogs, selectedCatalog])

  const handleRemoveCatalog = (catalogId: string) => {

    deleteCatalog(catalogId)

    setCatalogs((prevCatalogs) => prevCatalogs.filter((catalog) => catalog.id !== catalogId))
    // Se o catálogo removido for o que está selecionado, desseleciona
    if (selectedCatalog && selectedCatalog.id === catalogId) {
      setSelectedCatalog(null)
    }
  }

  return (
    <>
      {/* Modal Principal dos Catálogos */}
      <Dialog open={isOpen} onOpenChange={handleClose}>
        <DialogContent className="max-w-4xl max-h-[80vh] overflow-hidden flex flex-col">
          <DialogHeader className="flex-shrink-0">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                {selectedCatalog && (
                  <Button variant="ghost" size="sm" onClick={handleBackToCatalogs} className="mr-2">
                    <ArrowLeft className="h-4 w-4" />
                  </Button>
                )}
                <DialogTitle>{selectedCatalog ? selectedCatalog.name : "Catálogos"}</DialogTitle>
              </div>

              <div className="flex items-center gap-2 mr-5">
                {!selectedCatalog && (
                  <Button size="sm" onClick={() => setIsAddCatalogModalOpen(true)}>
                    <Plus className="h-4 w-4 mr-2" />
                    Adicionar Catálogo
                  </Button>
                )}
              </div>
            </div>
          </DialogHeader>

          <div className="flex-1 overflow-auto">
            {!selectedCatalog ? (
              // Grid de Catálogos
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-1">
                {catalogs.map((catalog) => (
                  <Card
                    key={catalog.id}
                    className="cursor-pointer hover:shadow-lg transition-shadow"
                    onClick={() => handleCatalogClick(catalog)}
                  >
                    <CardContent className="p-4">
                      <div className="aspect-square relative mb-3 bg-muted rounded-lg overflow-hidden">
                        <img
                          src={catalog.thumbnail || "/placeholder.svg"}
                          alt={catalog.name}
                          className="object-cover"
                        />
                      </div>
                      <h3 className="font-semibold text-center">{catalog.name}</h3>
                      <p className="text-sm text-muted-foreground text-center mt-1 mb-3">
                        {catalog.pieces.length} {catalog.pieces.length === 1 ? "peça" : "peças"}
                      </p>
                      <div className="flex justify-center flex-col">
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={(e) => {
                            e.stopPropagation()
                            handleShareCatalog(catalog)
                          }}
                          className="w-full m-1"
                        >
                          <Share className="h-4 w-4 mr-2" />
                          Compartilhar
                        </Button>
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={(e) => {
                            e.stopPropagation()
                            handleRemoveCatalog(catalog.id)
                          }}
                          className="w-full m-1 text-red-600 hover:text-red-700 hover:bg-red-50" // Ajustado para ocupar espaço
                        >
                          <Trash2 className="h-4 w-4 mr-2" />
                          Excluir
                        </Button>
                      </div>
                    </CardContent>
                  </Card>
                ))}

                {catalogs.length === 0 && (
                  <div className="col-span-full flex flex-col items-center justify-center py-12 text-muted-foreground">
                    <Package className="h-12 w-12 mb-4" />
                    <p>Nenhum catálogo encontrado</p>
                    <p className="text-sm">Clique em "Adicionar Catálogo" para começar</p>
                  </div>
                )}
              </div>
            ) : (
              // Grid de Peças do Catálogo Selecionado
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 p-1">
                {selectedCatalog.pieces.map((piece) => (
                  <Card key={piece.id} className="hover:shadow-lg transition-shadow">
                    <CardContent className="p-4">
                      <div className="aspect-square relative mb-3 bg-muted rounded-lg overflow-hidden">
                        <img src={piece.image || "/placeholder.svg"} alt={piece.name} className="object-cover h-full" />
                      </div>
                      <h4 className="font-medium text-sm mb-1">{piece.name}</h4>
                      {/**<p className="text-lg font-bold text-primary mb-3">R$ {piece.price.toFixed(2).replace(".", ",")}</p> */}
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => handleRemovePiece(piece.id)}
                        className="w-full text-red-600 hover:text-red-700 hover:bg-red-50"
                      >
                        <Trash2 className="h-4 w-4 mr-2" />
                        Remover
                      </Button>
                    </CardContent>
                  </Card>
                ))}

                {selectedCatalog.pieces.length === 0 && (
                  <div className="col-span-full flex flex-col items-center justify-center py-12 text-muted-foreground">
                    <ImageIcon className="h-12 w-12 mb-4" />
                    <p>Nenhuma peça encontrada</p>
                    <p className="text-sm">Este catálogo ainda não possui peças</p>
                  </div>
                )}
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal de Adicionar Catálogo */}
      <Dialog open={isAddCatalogModalOpen} onOpenChange={setIsAddCatalogModalOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Novo Catálogo</DialogTitle>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label htmlFor="catalog-name">Nome do Catálogo</Label>
              <Input
                id="catalog-name"
                placeholder="Digite o nome do catálogo"
                value={newCatalogName}
                onChange={(e) => setNewCatalogName(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleAddCatalog()
                  }
                }}
              />
            </div>
          </div>
          <div className="flex justify-end gap-2">
            <Button
              variant="outline"
              onClick={() => {
                setIsAddCatalogModalOpen(false)
                setNewCatalogName("")
              }}
            >
              Cancelar
            </Button>
            <Button onClick={handleAddCatalog}>Salvar</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}